import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    "nav.findCraftsmen": "Find Craftsmen",
    "nav.browseJobs": "Browse Jobs",
    "nav.postJob": "Post a Job",
    "nav.dashboard": "Dashboard",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.logout": "Log out",
    "hero.eyebrow": "Local trades, verified & rated",
    "promo.headline": "Launch offer: the first 200 craftsmen get 1 lead credit free!",
    "promo.only": "Only",
    "promo.cta": "Claim it now",
    "hero.title": "Find the right craftsman for every job",
    "hero.searchPlaceholder": "What do you need done?",
    "hero.cityPlaceholder": "City",
    "hero.search": "Search",
    "hero.postJob": "Post a job — it's free",
    "categories.title": "Popular trades",
    "categories.eyebrow": "Browse by trade",
    "categories.find": "Find pros",
    "categories.subtitle": "Browse skilled professionals by specialty",
    "how.title": "How it works",
    "how.eyebrow": "In 3 simple steps",
    "how.subtitle": "From posting your job to hiring the right pro — always free for customers.",
    "how.freeBadge": "100% free for customers",
    "how.step": "Step",
    "how.cta": "Post your job for free",
    "how.s1t": "Describe your job for free",
    "how.s1d": "Tell us what needs doing, add photos and your location. Takes 2 minutes — free and non-binding.",
    "how.s2t": "Receive matching offers",
    "how.s2d": "Verified craftsmen near you reach out directly with their quotes. You compare at your own pace.",
    "how.s3t": "Hire with confidence",
    "how.s3d": "Check real reviews, ratings and prices, then book the pro that fits you best.",
    "stats.craftsmen": "Verified craftsmen",
    "stats.jobs": "Jobs completed",
    "stats.rating": "Average rating",
    "craftsmen.title": "Verified craftsmen",
    "craftsmen.eyebrow": "Trusted professionals",
    "craftsmen.verified": "Verified",
    "craftsmen.subtitle": "Skilled, rated professionals ready to help",
    "craftsmen.allTrades": "All trades",
    "craftsmen.viewProfile": "View profile",
    "craftsmen.empty": "No craftsmen match your search.",
    "jobs.title": "Open jobs",
    "jobs.subtitle": "Find work near you and send your offer",
    "jobs.allCategories": "All categories",
    "jobs.budget": "Budget",
    "jobs.applications": "offers",
    "jobs.view": "View & apply",
    "jobs.empty": "No open jobs right now.",
    "job.description": "Description",
    "job.apply": "Send your offer",
    "job.yourMessage": "Your message",
    "job.yourPrice": "Your price (DH)",
    "job.submit": "Submit offer",
    "job.applied": "Offer sent!",
    "job.offers": "Offers received",
    "job.noOffers": "No offers yet.",
    "postJob.title": "Post a new job",
    "postJob.jobTitle": "Job title",
    "postJob.category": "Category",
    "postJob.city": "City",
    "postJob.budget": "Budget (DH, optional)",
    "postJob.desc": "Describe the work",
    "postJob.photos": "Photos (optional)",
    "postJob.photosHint": "Add photos of the problem so craftsmen can give accurate offers.",
    "postJob.submit": "Publish job",
    "postJob.success": "Your job is live!",
    "auth.loginTitle": "Welcome back",
    "auth.registerTitle": "Create your account",
    "auth.name": "Full name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.role.customer": "I need a craftsman",
    "auth.role.craftsman": "I am a craftsman",
    "auth.haveAccount": "Already have an account?",
    "auth.noAccount": "Don't have an account?",
    "auth.loginBtn": "Log in",
    "auth.registerBtn": "Create account",
    "auth.emailLang": "Email language",
    "auth.emailLangHint": "We'll send all emails (confirmation, receipts, reminders) in this language.",
    "settings.emailLang": "Email language",
    "settings.emailLangHint": "Language used for all emails we send you.",
    "settings.langSaved": "Email language updated",
    "auth.forgotPassword": "Forgot password?",
    "auth.forgotTitle": "Reset your password",
    "auth.forgotDesc": "Enter your email and we'll send you a link to reset your password.",
    "auth.sendResetLink": "Send reset link",
    "auth.resetSent": "If an account exists for this email, a reset link has been sent. Please check your inbox.",
    "auth.resetTitle": "Choose a new password",
    "auth.newPassword": "New password",
    "auth.setNewPassword": "Set new password",
    "auth.resetSuccess": "Your password has been reset. You can now log in.",
    "auth.resetInvalid": "This reset link is invalid or has expired. Please request a new one.",
    "auth.backToLogin": "Back to login",
    "dash.myJobs": "My jobs",
    "dash.myApplications": "My offers",
    "dash.profile": "My profile",
    "dash.noJobs": "You haven't posted any jobs yet.",
    "dash.noApps": "You haven't sent any offers yet.",
    "dash.editProfile": "Edit profile",
    "dash.saveProfile": "Save profile",
    "dash.trade": "Trade",
    "dash.bio": "Bio",
    "dash.skills": "Skills (comma separated)",
    "dash.rate": "Hourly rate (DH)",
    "dash.saved": "Profile saved!",
    "profile.reviews": "reviews",
    "profile.jobsDone": "jobs done",
    "profile.verified": "Verified",
    "profile.from": "from",
    "profile.contact": "Message craftsman",
    "profile.contactNote": "You can't contact craftsmen directly. Post a free job and verified craftsmen will send you offers.",
    "profile.postJobCta": "Post a job",
    "footer.tagline": "The trusted marketplace connecting you with skilled local craftsmen.",
    "footer.rights": "All rights reserved.",
    "common.perHour": "/hr",
    "nav.messages": "Messages",
    "nav.admin": "Admin",
    "status.open": "Open",
    "status.assigned": "Assigned",
    "status.completed": "Completed",
    "dash.acceptOffer": "Accept offer",
    "dash.accepted": "Accepted",
    "dash.markComplete": "Mark completed",
    "dash.leaveReview": "Leave a review",
    "dash.reviewed": "Reviewed",
    "dash.assignedTo": "Assigned to",
    "dash.message": "Message",
    "review.title": "Rate this craftsman",
    "review.comment": "Your comment",
    "review.submit": "Submit review",
    "review.success": "Thanks for your review!",
    "portfolio.title": "Portfolio",
    "portfolio.upload": "Upload photos",
    "portfolio.uploading": "Uploading…",
    "chat.title": "Messages",
    "chat.placeholder": "Type a message…",
    "chat.send": "Send",
    "chat.noThreads": "No conversations yet.",
    "chat.back": "Back",
    "admin.title": "Admin panel",
    "admin.users": "Users",
    "admin.jobs": "Jobs",
    "admin.craftsmen": "Craftsmen",
    "admin.reviews": "Reviews",
    "admin.delete": "Delete",
    "admin.verify": "Toggle verify",
    "admin.confirmDelete": "Delete this item?",
    "nav.map": "Map",
    "again.title": "Need something else done?",
    "again.sub": "Just post a new job, free of charge, with your city already filled in.",
    "again.same": "Hire this craftsman again",
    "again.other": "Find another trade",
    "again.banner": "This request goes directly to {name}. Other craftsmen cannot see it.",
    "inv.title": "Personal requests for you",
    "inv.sub": "Customers who were happy with you would like to hire you again.",
    "inv.view": "View request",
    "dash.completeTitle": "Complete the job and rate the craftsman",
    "dash.completeHint": "We need your rating to complete the job. It helps other customers and the craftsman.",
    "dash.completeSubmit": "Rate & complete job",
    "dash.pickStars": "Please choose a star rating.",
    "dash.doneQ": "Is the work done?",
    "dash.doneHint": "Confirm the job, then you can review the craftsman. Without confirmation it is automatically set to “Completed” after 30 days",
    "dash.doneDays": "{n} days left",
    "dash.doneToday": "today",
    "dash.doneBtn": "Yes, the job is done",
    "dash.doneConfirm": "Confirm the job as completed now?",
    "dash.autoDone": "Automatically completed after 30 days",
    "prof.name": "Name",
    "prof.optional": "optional",
    "prof.phoneHint": "The craftsman only sees your number after you accept their offer.",
    "prof.customerPhone": "Customer's phone",
    "prof.save": "Save",
    "acct.zoneHint": "Do you no longer want to use MyMoalem? Here you can delete your account and personal data.",
    "acct.delete": "Delete account",
    "acct.title": "Delete account permanently?",
    "acct.intro": "This cannot be undone.",
    "acct.pCustomer": "Your open jobs will be withdrawn. Your name and email address will be removed.",
    "acct.pCraftsman": "Your profile, open offers and remaining lead balance will be deleted. There is no refund.",
    "acct.pLaw": "We must keep payment records by law, but they will be separated from your name.",
    "acct.pActive": "If you have a job in progress, complete it first.",
    "acct.password": "Your password to confirm",
    "acct.confirm": "Yes, delete account permanently",
    "acct.cancel": "Cancel",
    "acct.done": "Your account has been deleted.",
    "acct.zone": "Account",
    "nav.myProfile": "My profile",
    "dash.phone": "Phone / WhatsApp",
    "dash.phoneHint": "Only shown to the customer who accepts your offer. Never shown publicly.",
    "dash.craftsmanPhone": "Craftsman's phone",
    "dash.offersBanner": "You have received offers – compare and accept now",
    "dash.offersHint": "Compare price, rating and message and accept the right offer with one click.",
    "dash.cheapest": "Lowest price",
    "dash.bestRated": "Best rated",
    "dash.viewProfile": "View profile",
    "dash.acceptConfirm": "Accept this offer now? The other offers will be declined.",
    "dash.step1": "Offers",
    "dash.step2": "Craftsman chosen",
    "dash.step3": "Done",
    "dash.waiting": "No offers yet. As soon as a craftsman responds you will see it here and a number appears in the menu.",
    "dash.jobsDone": "completed jobs",
    "chat.needsReply": "Reply needed",
    "chat.offer": "Offer",
    "chat.newOffer": "New offer",
    "guard.hint": "Please do not include phone numbers, email addresses or links. Contact runs through MyMoalem – you exchange details after the job is awarded.",
    "guard.hintChat": "Until the job is awarded, phone numbers, email addresses and links are not allowed in the chat.",
    "footer.contact": "Contact",
    "contact.title": "Contact & report a problem",
    "contact.intro": "Have a question, a problem or a complaint? Write to us – we will reply by email as soon as possible.",
    "contact.name": "Your name",
    "contact.email": "Your email",
    "contact.topic": "What is it about?",
    "contact.t.question": "Question",
    "contact.t.problem": "Report a problem",
    "contact.t.complaint": "Complaint",
    "contact.t.other": "Other",
    "contact.message": "Your message",
    "contact.messagePh": "Please describe as precisely as possible what it is about (at least 10 characters).",
    "contact.send": "Send message",
    "contact.thanks": "Thank you! Your message has arrived. You will receive a confirmation by email.",
    "contact.error": "Could not send. Please check your details and try again later.",
    "val.v1n": "0 MAD",
    "val.v1l": "cost for customers – always",
    "val.v2n": "0 %",
    "val.v2l": "commission on your job",
    "val.v3n": "4 languages",
    "val.v3l": "Deutsch · Français · العربية · English",
    "hero.subtitle": "Post your project for free and get quotes from verified local professionals – no fees and no hidden costs. You decide which offer you accept.",
    "nav.postFree": "Post a job for free",
    "free.badge": "100% free for customers",
    "free.chip1": "No fees",
    "free.chip2": "No hidden costs",
    "free.chip3": "No obligation",
    "free.cta": "Post a job for free",
    "reg.custTitle": "For customers only – 100% free",
    "reg.custBody": "Everyone can post their job here and receive offers from qualified craftsmen. You never pay anything. The craftsmen pay for the contact themselves.",
    "reg.craftTitle": "For craftsmen",
    "reg.craftBody": "Registration is free. You only pay when you submit an offer: one lead per offer.",
    "postJob.freeInfo": "Free for you – no fees. Craftsmen contact you with their offers and you decide freely.",
    "fair.custTitle": "For customers",
    "fair.custSub": "I'm looking for a craftsman",
    "fair.k1t": "Post for free",
    "fair.k1d": "Publishing a job costs you nothing.",
    "fair.k2t": "Delete until the first offer",
    "fair.k2d": "As long as no craftsman has made an offer, you can delete your job at any time.",
    "fair.k3t": "After that, the job stays",
    "fair.k3d": "Once a craftsman has already invested time, the job remains. Simply choose the offer that suits you – if there is a problem, we are happy to help.",
    "fair.k4t": "Genuine jobs only",
    "fair.k4d": "Jobs should be real. If several craftsmen report a job as not genuine, it is blocked.",
    "fair.k5t": "Review after completion",
    "fair.k5d": "Once the work is done, you can review the craftsman and help other customers.",
    "fair.craftTitle": "For craftsmen",
    "fair.craftSub": "I'm looking for jobs",
    "fair.h1t": "Sign up for free",
    "fair.h1d": "Creating your profile and browsing jobs costs nothing.",
    "fair.h2t": "One offer = one lead",
    "fair.h2d": "A lead is only deducted when you submit an offer. You buy leads conveniently by bank transfer.",
    "fair.h3t": "Lead refunded for non-genuine jobs",
    "fair.h3d": "If at least two craftsmen report a job as not genuine, you get your lead back.",
    "fair.h4t": "Fully documented",
    "fair.h4d": "Every order and approval of leads is recorded with a date so that everything remains traceable.",
    "fair.h5t": "Fair chances",
    "fair.h5d": "The customer decides freely. Good reviews increase your chances of further jobs.",
    "fair.eyebrow": "Fair for both sides",
    "fair.title": "Clear rules so everyone can rely on MyMoalem",
    "fair.intro": "We want customers and craftsmen to be able to trust each other. That is why a few simple rules apply – explained briefly and clearly here.",
    "fair.foot": "Together we ensure respectful dealings – from the first request to the finished job.",
    "status.withdrawn": "Withdrawn",
    "dash.deleteJob": "Delete job",
    "dash.deleteConfirm": "Do you really want to delete this job? This is only possible as long as no craftsman has made an offer.",
    "dash.jobDeleted": "Job deleted",
    "dash.cannotDelete": "Deleting is no longer possible: craftsmen have already sent offers. Choose an offer or contact us if something is wrong. This protects the craftsmen who have already invested time for you.",
    "dash.deleteHint": "You can delete this job as long as no craftsman has made an offer.",
    "recruit.title": "Looking for jobs?",
    "recruit.sub": "Grow your business with MyMoalem",
    "recruit.body": "MyMoalem connects you with customers in your city. Sign up for free, see matching jobs near you and contact customers directly – small or large jobs, you decide.",
    "recruit.cta": "Free sign-up for craftsmen",
    "topbar.text": "Are you a craftsman looking for jobs?",
    "topbar.link": "Sign up for free",
    "nav.findJobs": "Find jobs",
    "nav.myJobs": "My jobs",
    "nav.myApps": "My applications",
    "nav.credits": "Credits",
    "aud.customerTitle": "I'm looking for a craftsman",
    "aud.customerLine": "Post your job for free and receive offers",
    "aud.customerBtn": "Post a job",
    "aud.c1": "Describe your job",
    "aud.c2": "Receive offers from craftsmen",
    "aud.c3": "Choose the best one",
    "aud.craftTitle": "I'm a craftsman",
    "aud.craftLine": "Find jobs in your city and contact customers",
    "aud.craftBtn": "Find jobs",
    "aud.h1": "Sign up for free",
    "aud.h2": "Find matching jobs",
    "aud.h3": "Contact customers",
    "aud.steps": "How it works",
    "map.title": "Explore Morocco",
    "map.subtitle": "Craftsmen and jobs across Moroccan cities",
    "map.craftsmen": "Craftsmen",
    "map.jobs": "Jobs",
    "credits.title": "Lead Credits",
    "credits.balance": "Available credits",
    "credits.buy": "Buy credits",
    "credits.buyNow": "Buy lead credits",
    "credits.perLead": "1 credit = 1 client contact (100 DH value)",
    "credits.leads": "leads",
    "credits.history": "Credit history",
    "credits.need": "You have no credits left. Buy lead credits to contact clients.",
    "pay.confirming": "Confirming your payment…",
    "pay.success": "Payment successful!",
    "pay.successMsg": "Your lead credits have been added to your account.",
    "pay.failed": "We couldn't confirm your payment. Contact support if you were charged.",
    "pay.cancelled": "Payment cancelled. No charge was made.",
    "pay.toDashboard": "Back to dashboard",
    "admin.credits": "Credits",
    "admin.orders": "Payments",
    "admin.confirm": "Confirm",
    "admin.cancel": "Cancel",
    "admin.noOrders": "No payment orders yet.",
    "credits.pending": "Pending",
    "credits.confirmed": "Confirmed",
    "credits.cancelled": "Cancelled",
    "admin.grant": "Grant",
    "nav.pricing": "Pricing",
    "pricing.title": "Simple pricing for craftsmen",
    "pricing.subtitle": "Customers post jobs for free. Craftsmen buy lead credits and spend 1 credit each time they contact a client or send an offer.",
    "pricing.mustBuy": "To accept a job or send an offer, a craftsman must first purchase a credit package.",
    "pricing.cta": "Start as a craftsman",
    "pricing.gotoDash": "Buy credits",
    "pricing.popular": "Best value",
    "pricing.save": "Save",
    "pricing.trust1": "Secure payment by bank transfer",
    "pricing.trust2": "No hidden fees",
    "legal.badge": "Good to know",
    "legal.title": "We only broker the contact",
    "legal.p1": "MyMoalem is purely an intermediary platform: we connect customers and craftsmen and pass on contact details.",
    "legal.p2": "Any contract for the work is concluded directly and exclusively between the customer and the craftsman. MyMoalem is not a party to that contract.",
    "legal.p3": "Execution, quality, pricing, warranty and any complaints are the sole responsibility of the customer and the craftsman and must be settled directly between them.",
    "legal.p4": "MyMoalem accepts no liability for jobs that come about or for their fulfilment.",
    "legal.pageTitle": "Terms & Legal Notice",
    "footer.pricing": "Pricing",
    "footer.legal": "Legal & Terms",
    "apply.cost": "This contact costs 1 lead credit.",
    "apply.ack": "I understand that 1 credit will be used and that MyMoalem only brokers the contact. The contract and any complaints are solely between me and the client.",
    "auth.acceptTerms": "I accept the Terms and the Privacy Policy.",
    "verify.sentTitle": "Check your inbox",
    "verify.sentMsg": "We sent a confirmation link to",
    "verify.loading": "Confirming your email…",
    "verify.okTitle": "Email confirmed!",
    "verify.okMsg": "Your account is now active.",
    "verify.goDashboard": "Go to dashboard",
    "verify.errTitle": "Link invalid or expired",
    "verify.errMsg": "This confirmation link is invalid or has already been used.",
    "verify.needVerify": "Please confirm your email address first. Check your inbox.",
    "verify.resend": "Resend confirmation email",
    "verify.resent": "Confirmation email sent.",
    "report.button": "Report as fake",
    "report.title": "Report this job",
    "report.desc": "Only report jobs you believe are fake or misleading. If confirmed, your credit is refunded.",
    "report.placeholder": "What's wrong with this job? (optional)",
    "report.submit": "Submit report",
    "report.cancel": "Cancel",
    "report.received": "Report received. Our team will review it.",
    "report.autoConfirmed": "This job was flagged as fake. Your credit has been refunded.",
    "report.done": "Reported",
    "trust.title": "About this client",
    "trust.verified": "Trusted client",
    "trust.new": "New client",
    "trust.flagged": "Flagged client",
    "trust.jobsPosted": "jobs posted",
    "trust.memberSince": "Member since",
    "trust.hint": "Tip: before spending a credit, check this client's details — member since, jobs posted and trust status. Be cautious with brand-new or flagged clients.",
    "admin.reports": "Reports",
    "admin.confirmFake": "Confirm fake & refund",
    "admin.dismiss": "Dismiss",
    "admin.sevDisable": "Disable job only",
    "admin.sevFlag": "Disable + flag client",
    "admin.sevBlock": "Disable + block client",
    "admin.flagged": "Flagged",
    "admin.blocked": "Blocked",
    "admin.block": "Block",
    "admin.unblock": "Unblock",
    "admin.leadBought": "Bought",
    "admin.leadFree": "Free",
    "admin.leadUsed": "Used",
    "admin.leadActive": "Active",
    "admin.leadLow": "Almost out of leads",
    "admin.remind": "Send top-up reminder",
    "admin.unverified": "Email not confirmed",
    "admin.resendVerify": "Resend confirmation email",
    "admin.resendWelcome": "Resend welcome email",
    "admin.mailSent": "Email sent",
    "admin.mailFailed": "Email could not be sent",
    "admin.reporters": "reporters",
    "admin.noReports": "No reports.",
    "admin.reportResolved": "Report resolved",
    "admin.deleted": "Deleted",
    "admin.grantPrompt": "Credits to add:",
    "dash.avatar": "Avatar",
    "profile.responseTime": "~1h response time",
    "role.admin": "Admin",
    "role.craftsman": "Craftsman",
    "role.customer": "Customer",
    "status.open": "Open",
    "status.assigned": "Assigned",
    "status.accepted": "Accepted",
    "status.completed": "Completed",
    "status.disabled": "Disabled",
    "jobs.application": "offer",
    "footer.imprint": "Imprint",
    "footer.privacy": "Privacy",
    "imprint.title": "Imprint",
    "imprint.body": "Information pursuant to legal disclosure requirements:\n\nMyMoalem – itnetic Group S.A.R.L.\n[Street & No.], [Postal code] [City], Morocco\nTrade register (RC): [RC no.] · ICE: [ICE no.]\nEmail: contact@mymoalem.com\n\nResponsible for content: itnetic Group S.A.R.L.\n\nMyMoalem is purely an intermediary platform. Contracts for craftsman services are concluded exclusively between the customer and the craftsman.",
    "privacy.title": "Privacy Policy",
    "privacy.body": "Privacy at a glance:\n\n1. Data we collect: account data (name, email), profile and job data, messages, and payment data (bank transfers – we do not store full card details).\n\n2. Purpose: providing the brokerage between customers and craftsmen, handling lead credits and communication.\n\n3. Sharing: contact details are passed to the respective other party for the purpose of brokerage. Payments are processed by bank transfer.\n\n4. Your rights: access, correction and deletion of your data. Contact: contact@mymoalem.com\n\n5. Retention: data is stored only as long as necessary for the brokerage and legal obligations.",
  },
  de: {
    "nav.findCraftsmen": "Handwerker finden",
    "nav.browseJobs": "Aufträge ansehen",
    "nav.postJob": "Auftrag einstellen",
    "nav.dashboard": "Dashboard",
    "nav.login": "Anmelden",
    "nav.register": "Registrieren",
    "nav.logout": "Abmelden",
    "hero.eyebrow": "Lokale Handwerker, geprüft & bewertet",
    "promo.headline": "Start-Aktion: Die ersten 200 Handwerker erhalten 1 Lead-Credit gratis!",
    "promo.only": "Nur noch",
    "promo.cta": "Jetzt sichern",
    "hero.title": "Finde den richtigen Handwerker für jeden Auftrag",
    "hero.searchPlaceholder": "Was soll erledigt werden?",
    "hero.cityPlaceholder": "Stadt",
    "hero.search": "Suchen",
    "hero.postJob": "Auftrag einstellen — kostenlos",
    "categories.title": "Beliebte Gewerke",
    "categories.eyebrow": "Nach Fachgebiet",
    "categories.find": "Profis finden",
    "categories.subtitle": "Finde Profis nach Fachgebiet",
    "how.title": "So funktioniert's",
    "how.eyebrow": "In 3 einfachen Schritten",
    "how.subtitle": "Vom Auftrag bis zum passenden Profi – für Kunden immer kostenlos.",
    "how.freeBadge": "100% kostenlos für Kunden",
    "how.step": "Schritt",
    "how.cta": "Auftrag kostenlos veröffentlichen",
    "how.s1t": "Auftrag kostenlos beschreiben",
    "how.s1d": "Sag uns in 2 Minuten, was zu tun ist – mit Fotos und Ort. Völlig kostenlos und unverbindlich.",
    "how.s2t": "Passende Angebote erhalten",
    "how.s2d": "Geprüfte Handwerker aus deiner Region melden sich direkt bei dir mit ihrem Angebot. Du wählst in Ruhe aus.",
    "how.s3t": "Sicher beauftragen",
    "how.s3d": "Vergleiche echte Bewertungen, Profile und Preise – und beauftrage mit gutem Gefühl den richtigen Profi.",
    "stats.craftsmen": "Geprüfte Handwerker",
    "stats.jobs": "Erledigte Aufträge",
    "stats.rating": "Durchschnittsbewertung",
    "craftsmen.title": "Geprüfte Handwerker",
    "craftsmen.eyebrow": "Vertrauenswürdige Profis",
    "craftsmen.verified": "Geprüft",
    "craftsmen.subtitle": "Qualifizierte, bewertete Profis bereit zu helfen",
    "craftsmen.allTrades": "Alle Gewerke",
    "craftsmen.viewProfile": "Profil ansehen",
    "craftsmen.empty": "Keine Handwerker gefunden.",
    "jobs.title": "Offene Aufträge",
    "jobs.subtitle": "Finde Arbeit in deiner Nähe und sende dein Angebot",
    "jobs.allCategories": "Alle Kategorien",
    "jobs.budget": "Budget",
    "jobs.applications": "Angebote",
    "jobs.view": "Ansehen & bewerben",
    "jobs.empty": "Derzeit keine offenen Aufträge.",
    "job.description": "Beschreibung",
    "job.apply": "Angebot senden",
    "job.yourMessage": "Deine Nachricht",
    "job.yourPrice": "Dein Preis (DH)",
    "job.submit": "Angebot absenden",
    "job.applied": "Angebot gesendet!",
    "job.offers": "Erhaltene Angebote",
    "job.noOffers": "Noch keine Angebote.",
    "postJob.title": "Neuen Auftrag einstellen",
    "postJob.jobTitle": "Auftragstitel",
    "postJob.category": "Kategorie",
    "postJob.city": "Stadt",
    "postJob.budget": "Budget (DH, optional)",
    "postJob.desc": "Beschreibe die Arbeit",
    "postJob.photos": "Fotos (optional)",
    "postJob.photosHint": "Füge Fotos des Problems hinzu, damit Handwerker genaue Angebote machen können.",
    "postJob.submit": "Auftrag veröffentlichen",
    "postJob.success": "Dein Auftrag ist online!",
    "auth.loginTitle": "Willkommen zurück",
    "auth.registerTitle": "Konto erstellen",
    "auth.name": "Vollständiger Name",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.role.customer": "Ich suche einen Handwerker",
    "auth.role.craftsman": "Ich bin Handwerker",
    "auth.haveAccount": "Bereits ein Konto?",
    "auth.noAccount": "Noch kein Konto?",
    "auth.loginBtn": "Anmelden",
    "auth.registerBtn": "Konto erstellen",
    "auth.emailLang": "E-Mail-Sprache",
    "auth.emailLangHint": "Wir senden alle E-Mails (Bestätigung, Belege, Erinnerungen) in dieser Sprache.",
    "settings.emailLang": "E-Mail-Sprache",
    "settings.emailLangHint": "Sprache für alle E-Mails, die wir dir senden.",
    "settings.langSaved": "E-Mail-Sprache aktualisiert",
    "auth.forgotPassword": "Passwort vergessen?",
    "auth.forgotTitle": "Passwort zurücksetzen",
    "auth.forgotDesc": "Gib deine E-Mail-Adresse ein, wir senden dir einen Link zum Zurücksetzen deines Passworts.",
    "auth.sendResetLink": "Link senden",
    "auth.resetSent": "Falls ein Konto mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet. Bitte prüfe dein Postfach.",
    "auth.resetTitle": "Neues Passwort wählen",
    "auth.newPassword": "Neues Passwort",
    "auth.setNewPassword": "Neues Passwort speichern",
    "auth.resetSuccess": "Dein Passwort wurde zurückgesetzt. Du kannst dich jetzt anmelden.",
    "auth.resetInvalid": "Dieser Link ist ungültig oder abgelaufen. Bitte fordere einen neuen an.",
    "auth.backToLogin": "Zurück zur Anmeldung",
    "dash.myJobs": "Meine Aufträge",
    "dash.myApplications": "Meine Angebote",
    "dash.profile": "Mein Profil",
    "dash.noJobs": "Du hast noch keine Aufträge eingestellt.",
    "dash.noApps": "Du hast noch keine Angebote gesendet.",
    "dash.editProfile": "Profil bearbeiten",
    "dash.saveProfile": "Profil speichern",
    "dash.trade": "Gewerk",
    "dash.bio": "Über mich",
    "dash.skills": "Fähigkeiten (kommagetrennt)",
    "dash.rate": "Stundensatz (DH)",
    "dash.saved": "Profil gespeichert!",
    "profile.reviews": "Bewertungen",
    "profile.jobsDone": "Aufträge erledigt",
    "profile.verified": "Verifiziert",
    "profile.from": "aus",
    "profile.contact": "Handwerker anschreiben",
    "profile.contactNote": "Kunden können Handwerker nicht direkt anschreiben. Veröffentliche kostenlos eine Mission — geprüfte Handwerker senden dir Angebote.",
    "profile.postJobCta": "Mission veröffentlichen",
    "footer.tagline": "Der vertrauenswürdige Marktplatz, der dich mit lokalen Handwerkern verbindet.",
    "footer.rights": "Alle Rechte vorbehalten.",
    "common.perHour": "/Std",
    "nav.messages": "Nachrichten",
    "nav.admin": "Admin",
    "status.open": "Offen",
    "status.assigned": "Vergeben",
    "status.completed": "Erledigt",
    "dash.acceptOffer": "Angebot annehmen",
    "dash.accepted": "Angenommen",
    "dash.markComplete": "Als erledigt markieren",
    "dash.leaveReview": "Bewertung abgeben",
    "dash.reviewed": "Bewertet",
    "dash.assignedTo": "Vergeben an",
    "dash.message": "Nachricht",
    "review.title": "Handwerker bewerten",
    "review.comment": "Dein Kommentar",
    "review.submit": "Bewertung senden",
    "review.success": "Danke für deine Bewertung!",
    "portfolio.title": "Portfolio",
    "portfolio.upload": "Fotos hochladen",
    "portfolio.uploading": "Wird hochgeladen…",
    "chat.title": "Nachrichten",
    "chat.placeholder": "Nachricht schreiben…",
    "chat.send": "Senden",
    "chat.noThreads": "Noch keine Unterhaltungen.",
    "chat.back": "Zurück",
    "admin.title": "Admin-Bereich",
    "admin.users": "Benutzer",
    "admin.jobs": "Aufträge",
    "admin.craftsmen": "Handwerker",
    "admin.reviews": "Bewertungen",
    "admin.delete": "Löschen",
    "admin.verify": "Verifizierung umschalten",
    "admin.confirmDelete": "Dieses Element löschen?",
    "nav.map": "Karte",
    "again.title": "Brauchst du noch etwas erledigt?",
    "again.sub": "Gib einfach einen neuen Auftrag auf, kostenlos, mit deiner Stadt schon eingetragen.",
    "again.same": "Diesen Handwerker erneut beauftragen",
    "again.other": "Anderes Gewerk suchen",
    "again.banner": "Diese Anfrage geht direkt an {name}. Andere Handwerker sehen sie nicht.",
    "inv.title": "Persönliche Anfragen für dich",
    "inv.sub": "Kunden, die mit dir zufrieden waren, möchten dich erneut beauftragen.",
    "inv.view": "Anfrage ansehen",
    "dash.completeTitle": "Auftrag abschließen und Handwerker bewerten",
    "dash.completeHint": "Zum Abschließen brauchen wir deine Bewertung. Sie hilft anderen Kunden und dem Handwerker.",
    "dash.completeSubmit": "Bewerten & Auftrag abschließen",
    "dash.pickStars": "Bitte wähle Sterne aus.",
    "dash.doneQ": "Ist die Arbeit erledigt?",
    "dash.doneHint": "Bestätige den Auftrag, dann kannst du den Handwerker bewerten. Ohne Bestätigung wird er nach 30 Tagen automatisch auf „Erledigt“ gesetzt",
    "dash.doneDays": "noch {n} Tage",
    "dash.doneToday": "heute",
    "dash.doneBtn": "Ja, Auftrag ist erledigt",
    "dash.doneConfirm": "Auftrag jetzt als erledigt bestätigen?",
    "dash.autoDone": "Automatisch nach 30 Tagen abgeschlossen",
    "prof.name": "Name",
    "prof.optional": "freiwillig",
    "prof.phoneHint": "Der Handwerker sieht deine Nummer erst, nachdem du sein Angebot angenommen hast.",
    "prof.customerPhone": "Telefon des Kunden",
    "prof.save": "Speichern",
    "acct.zoneHint": "Du möchtest MyMoalem nicht mehr nutzen? Hier kannst du dein Konto und deine persönlichen Daten löschen.",
    "acct.delete": "Konto löschen",
    "acct.title": "Konto endgültig löschen?",
    "acct.intro": "Das kann nicht rückgängig gemacht werden.",
    "acct.pCustomer": "Deine offenen Aufträge werden zurückgezogen. Dein Name und deine E-Mail-Adresse werden entfernt.",
    "acct.pCraftsman": "Dein Profil, deine offenen Angebote und dein restliches Lead-Guthaben werden gelöscht. Es gibt dafür keine Erstattung.",
    "acct.pLaw": "Zahlungsbelege müssen wir gesetzlich aufbewahren, sie werden aber von deinem Namen getrennt.",
    "acct.pActive": "Hast du einen laufenden Auftrag, schließe ihn zuerst ab.",
    "acct.password": "Zur Bestätigung dein Passwort",
    "acct.confirm": "Ja, Konto endgültig löschen",
    "acct.cancel": "Abbrechen",
    "acct.done": "Dein Konto wurde gelöscht.",
    "acct.zone": "Konto",
    "nav.myProfile": "Mein Profil",
    "dash.phone": "Telefon / WhatsApp",
    "dash.phoneHint": "Wird nur dem Kunden angezeigt, dessen Angebot er annimmt. Öffentlich sichtbar ist sie nie.",
    "dash.craftsmanPhone": "Telefon des Handwerkers",
    "dash.offersBanner": "Du hast Angebote erhalten – jetzt vergleichen und annehmen",
    "dash.offersHint": "Vergleiche Preis, Bewertung und Nachricht und nimm das passende Angebot mit einem Klick an.",
    "dash.cheapest": "Günstigstes",
    "dash.bestRated": "Beste Bewertung",
    "dash.viewProfile": "Profil ansehen",
    "dash.acceptConfirm": "Dieses Angebot jetzt annehmen? Die anderen Angebote werden damit abgelehnt.",
    "dash.step1": "Angebote",
    "dash.step2": "Handwerker gewählt",
    "dash.step3": "Erledigt",
    "dash.waiting": "Noch keine Angebote. Sobald sich ein Handwerker meldet, siehst du es hier und bekommst oben im Menü eine Zahl.",
    "dash.jobsDone": "erledigte Aufträge",
    "chat.needsReply": "Antwort offen",
    "chat.offer": "Angebot",
    "chat.newOffer": "Neues Angebot",
    "guard.hint": "Bitte keine Telefonnummern, E-Mail-Adressen oder Links angeben. Der Kontakt läuft über MyMoalem – nach dem Zuschlag tauscht ihr die Daten aus.",
    "guard.hintChat": "Bis zum Zuschlag sind Telefonnummern, E-Mail-Adressen und Links im Chat nicht erlaubt.",
    "footer.contact": "Kontakt",
    "contact.title": "Kontakt & Problem melden",
    "contact.intro": "Du hast eine Frage, ein Problem oder eine Beschwerde? Schreib uns – wir melden uns so schnell wie möglich per E-Mail.",
    "contact.name": "Dein Name",
    "contact.email": "Deine E-Mail",
    "contact.topic": "Worum geht es?",
    "contact.t.question": "Frage",
    "contact.t.problem": "Problem melden",
    "contact.t.complaint": "Beschwerde",
    "contact.t.other": "Sonstiges",
    "contact.message": "Deine Nachricht",
    "contact.messagePh": "Bitte beschreibe möglichst genau, worum es geht (mindestens 10 Zeichen).",
    "contact.send": "Nachricht senden",
    "contact.thanks": "Danke! Deine Nachricht ist bei uns angekommen. Du bekommst eine Bestätigung per E-Mail.",
    "contact.error": "Senden nicht möglich. Bitte prüfe deine Angaben und versuche es später erneut.",
    "val.v1n": "0 MAD",
    "val.v1l": "Kosten für Kunden – immer",
    "val.v2n": "0 %",
    "val.v2l": "Provision auf deinen Auftrag",
    "val.v3n": "4 Sprachen",
    "val.v3l": "Deutsch · Français · العربية · English",
    "hero.subtitle": "Stelle dein Projekt kostenlos ein und erhalte Angebote von geprüften lokalen Profis – ohne Gebühren und ohne versteckte Kosten. Du entscheidest, welches Angebot du annimmst.",
    "nav.postFree": "Kostenlos Auftrag aufgeben",
    "free.badge": "100 % kostenlos für Kunden",
    "free.chip1": "Keine Gebühren",
    "free.chip2": "Keine versteckten Kosten",
    "free.chip3": "Unverbindlich",
    "free.cta": "Kostenlos Auftrag aufgeben",
    "reg.custTitle": "Nur für Kunden – 100 % kostenlos",
    "reg.custBody": "Hier stellt jeder seinen Auftrag ein und erhält Angebote von fachgerechten Handwerkern. Du zahlst nie etwas. Die Handwerker bezahlen selbst für den Kontakt.",
    "reg.craftTitle": "Für Handwerker",
    "reg.craftBody": "Die Registrierung ist kostenlos. Du bezahlst nur, wenn du ein Angebot abgibst: ein Lead pro Angebot.",
    "postJob.freeInfo": "Kostenlos für dich – keine Gebühren. Handwerker melden sich mit ihrem Angebot bei dir, du entscheidest frei.",
    "fair.custTitle": "Für Kunden",
    "fair.custSub": "Ich suche einen Handwerker",
    "fair.k1t": "Kostenlos einstellen",
    "fair.k1d": "Einen Auftrag zu veröffentlichen kostet dich nichts.",
    "fair.k2t": "Löschen bis zum ersten Angebot",
    "fair.k2d": "Solange noch kein Handwerker ein Angebot abgegeben hat, kannst du deinen Auftrag jederzeit wieder löschen.",
    "fair.k3t": "Danach bleibt der Auftrag bestehen",
    "fair.k3d": "Hat ein Handwerker schon Zeit investiert, bleibt der Auftrag erhalten. Wähle einfach das passende Angebot – bei Problemen helfen wir dir gern.",
    "fair.k4t": "Ernst gemeinte Aufträge",
    "fair.k4d": "Aufträge sollen echt sein. Wird ein Auftrag von mehreren Handwerkern als unseriös gemeldet, wird er gesperrt.",
    "fair.k5t": "Bewerten nach Abschluss",
    "fair.k5d": "Ist die Arbeit erledigt, kannst du den Handwerker bewerten und so anderen Kunden helfen.",
    "fair.craftTitle": "Für Handwerker",
    "fair.craftSub": "Ich suche Aufträge",
    "fair.h1t": "Kostenlos registrieren",
    "fair.h1d": "Dein Profil anlegen und Aufträge ansehen kostet nichts.",
    "fair.h2t": "Ein Angebot = ein Lead",
    "fair.h2d": "Nur wenn du ein Angebot abgibst, wird ein Lead abgebucht. Leads kaufst du bequem per Banküberweisung.",
    "fair.h3t": "Lead zurück bei unseriösen Aufträgen",
    "fair.h3d": "Melden mindestens zwei Handwerker einen Auftrag als nicht ernst gemeint, bekommst du deinen Lead zurück.",
    "fair.h4t": "Lückenlos dokumentiert",
    "fair.h4d": "Jede Bestellung und Freigabe von Leads wird mit Datum festgehalten, damit alles nachvollziehbar bleibt.",
    "fair.h5t": "Faire Chancen",
    "fair.h5d": "Der Kunde entscheidet frei. Gute Bewertungen erhöhen deine Chancen auf weitere Aufträge.",
    "fair.eyebrow": "Fair für beide Seiten",
    "fair.title": "Klare Regeln, damit sich alle auf MyMoalem verlassen können",
    "fair.intro": "Wir wollen, dass Kunden und Handwerker sich gegenseitig vertrauen können. Deshalb gelten ein paar einfache Regeln – hier kurz und verständlich erklärt.",
    "fair.foot": "Gemeinsam sorgen wir für einen respektvollen Umgang – von der ersten Anfrage bis zum erledigten Auftrag.",
    "status.withdrawn": "Zurückgezogen",
    "dash.deleteJob": "Auftrag löschen",
    "dash.deleteConfirm": "Möchtest du diesen Auftrag wirklich löschen? Das geht nur, solange noch kein Handwerker ein Angebot abgegeben hat.",
    "dash.jobDeleted": "Auftrag gelöscht",
    "dash.cannotDelete": "Löschen nicht mehr möglich: Es sind bereits Angebote von Handwerkern eingegangen. Wähle ein Angebot aus oder kontaktiere uns, falls etwas nicht stimmt. So schützen wir die Handwerker, die sich schon Zeit für dich genommen haben.",
    "dash.deleteHint": "Du kannst diesen Auftrag löschen, solange noch kein Handwerker ein Angebot abgegeben hat.",
    "recruit.title": "Auf der Suche nach Aufträgen?",
    "recruit.sub": "Wachse mit MyMoalem",
    "recruit.body": "MyMoalem bringt dich mit Kunden in deiner Stadt zusammen. Registriere dich kostenlos, sieh passende Aufträge in deiner Nähe und kontaktiere Kunden direkt – ob kleine oder große Aufträge, du entscheidest.",
    "recruit.cta": "Kostenlose Registrierung für Handwerker",
    "topbar.text": "Bist du Handwerker und suchst Aufträge?",
    "topbar.link": "Kostenlos registrieren",
    "nav.findJobs": "Aufträge finden",
    "nav.myJobs": "Meine Aufträge",
    "nav.myApps": "Meine Bewerbungen",
    "nav.credits": "Credits",
    "aud.customerTitle": "Ich suche einen Handwerker",
    "aud.customerLine": "Auftrag kostenlos einstellen und Angebote erhalten",
    "aud.customerBtn": "Auftrag aufgeben",
    "aud.c1": "Auftrag beschreiben",
    "aud.c2": "Angebote von Handwerkern erhalten",
    "aud.c3": "Den besten auswählen",
    "aud.craftTitle": "Ich bin Handwerker",
    "aud.craftLine": "Aufträge in deiner Stadt finden und Kunden kontaktieren",
    "aud.craftBtn": "Aufträge finden",
    "aud.h1": "Kostenlos registrieren",
    "aud.h2": "Passende Aufträge finden",
    "aud.h3": "Kunden kontaktieren",
    "aud.steps": "So funktioniert's",
    "map.title": "Marokko entdecken",
    "map.subtitle": "Handwerker und Aufträge in marokkanischen Städten",
    "map.craftsmen": "Handwerker",
    "map.jobs": "Aufträge",
    "credits.title": "Lead-Credits",
    "credits.balance": "Verfügbare Credits",
    "credits.buy": "Credits kaufen",
    "credits.buyNow": "Lead-Credits kaufen",
    "credits.perLead": "1 Credit = 1 Kundenkontakt (Wert 100 DH)",
    "credits.leads": "Leads",
    "credits.history": "Credit-Verlauf",
    "credits.need": "Du hast keine Credits mehr. Kaufe Lead-Credits, um Kunden zu kontaktieren.",
    "pay.confirming": "Zahlung wird bestätigt…",
    "pay.success": "Zahlung erfolgreich!",
    "pay.successMsg": "Deine Lead-Credits wurden deinem Konto gutgeschrieben.",
    "pay.failed": "Zahlung konnte nicht bestätigt werden. Kontaktiere den Support, falls du belastet wurdest.",
    "pay.cancelled": "Zahlung abgebrochen. Es wurde nichts berechnet.",
    "pay.toDashboard": "Zurück zum Dashboard",
    "admin.credits": "Credits",
    "admin.orders": "Zahlungen",
    "admin.confirm": "Bestätigen",
    "admin.cancel": "Stornieren",
    "admin.noOrders": "Noch keine Zahlungs-Bestellungen.",
    "credits.pending": "Ausstehend",
    "credits.confirmed": "Bestätigt",
    "credits.cancelled": "Storniert",
    "admin.grant": "Gutschreiben",
    "nav.pricing": "Preise",
    "pricing.title": "Faire Preise für Handwerker",
    "pricing.subtitle": "Kunden stellen Aufträge kostenlos ein. Handwerker kaufen Lead-Credits und geben pro Kundenkontakt bzw. Angebot 1 Credit aus.",
    "pricing.mustBuy": "Um einen Auftrag anzunehmen oder ein Angebot abzugeben, muss ein Handwerker zuerst ein Credit-Paket erwerben.",
    "pricing.cta": "Als Handwerker starten",
    "pricing.gotoDash": "Credits kaufen",
    "pricing.popular": "Bester Preis",
    "pricing.save": "Spare",
    "pricing.trust1": "Sichere Zahlung per Überweisung",
    "pricing.trust2": "Keine versteckten Gebühren",
    "legal.badge": "Gut zu wissen",
    "legal.title": "Wir vermitteln nur den Kontakt",
    "legal.p1": "MyMoalem ist ausschließlich eine Vermittlungsplattform: Wir stellen den Kontakt zwischen Kunden und Handwerkern her und geben Kontaktdaten weiter.",
    "legal.p2": "Der Vertrag über die Arbeiten kommt ausschließlich und direkt zwischen Kunde und Handwerker zustande. MyMoalem ist nicht Vertragspartei.",
    "legal.p3": "Für Ausführung, Qualität, Preise, Gewährleistung und etwaige Reklamationen sind allein Kunde und Handwerker verantwortlich und regeln diese direkt untereinander.",
    "legal.p4": "MyMoalem übernimmt keine Haftung für zustande gekommene Aufträge oder deren Erfüllung.",
    "legal.pageTitle": "AGB & Rechtlicher Hinweis",
    "footer.pricing": "Preise",
    "footer.legal": "Rechtliches & AGB",
    "apply.cost": "Dieser Kontakt kostet 1 Lead-Credit.",
    "apply.ack": "Ich verstehe, dass 1 Credit verwendet wird und MyMoalem nur den Kontakt vermittelt. Vertrag und etwaige Reklamationen liegen allein zwischen mir und dem Kunden.",
    "auth.acceptTerms": "Ich akzeptiere die AGB und die Datenschutzerklärung.",
    "verify.sentTitle": "Prüfe dein Postfach",
    "verify.sentMsg": "Wir haben einen Bestätigungslink gesendet an",
    "verify.loading": "E-Mail wird bestätigt…",
    "verify.okTitle": "E-Mail bestätigt!",
    "verify.okMsg": "Dein Konto ist jetzt aktiv.",
    "verify.goDashboard": "Zum Dashboard",
    "verify.errTitle": "Link ungültig oder abgelaufen",
    "verify.errMsg": "Dieser Bestätigungslink ist ungültig oder wurde bereits verwendet.",
    "verify.needVerify": "Bitte bestätige zuerst deine E-Mail-Adresse. Prüfe dein Postfach.",
    "verify.resend": "Bestätigungs-E-Mail erneut senden",
    "verify.resent": "Bestätigungs-E-Mail gesendet.",
    "report.button": "Als Fake melden",
    "report.title": "Diese Anzeige melden",
    "report.desc": "Melde nur Anzeigen, die du für Fake oder irreführend hältst. Bei Bestätigung wird dein Credit erstattet.",
    "report.placeholder": "Was stimmt mit dieser Anzeige nicht? (optional)",
    "report.submit": "Meldung senden",
    "report.cancel": "Abbrechen",
    "report.received": "Meldung erhalten. Unser Team prüft sie.",
    "report.autoConfirmed": "Diese Anzeige wurde als Fake markiert. Dein Credit wurde erstattet.",
    "report.done": "Gemeldet",
    "trust.title": "Über diesen Kunden",
    "trust.verified": "Vertrauenswürdiger Kunde",
    "trust.new": "Neuer Kunde",
    "trust.flagged": "Markierter Kunde",
    "trust.jobsPosted": "Aufträge eingestellt",
    "trust.memberSince": "Mitglied seit",
    "trust.hint": "Hinweis: Bevor du einen Credit einsetzt, beachte die Angaben des Kunden — Mitglied seit, eingestellte Aufträge und Vertrauensstatus. Sei bei ganz neuen oder markierten Kunden vorsichtig.",
    "admin.reports": "Meldungen",
    "admin.confirmFake": "Fake bestätigen & erstatten",
    "admin.dismiss": "Ablehnen",
    "admin.sevDisable": "Nur Anzeige deaktivieren",
    "admin.sevFlag": "Deaktivieren + Kunde markieren",
    "admin.sevBlock": "Deaktivieren + Kunde sperren",
    "admin.flagged": "Markiert",
    "admin.blocked": "Gesperrt",
    "admin.block": "Sperren",
    "admin.unblock": "Entsperren",
    "admin.leadBought": "Gekauft",
    "admin.leadFree": "Gratis",
    "admin.leadUsed": "Verbraucht",
    "admin.leadActive": "Aktiv",
    "admin.leadLow": "Limit fast erreicht",
    "admin.remind": "Auffüll-Erinnerung senden",
    "admin.unverified": "E-Mail nicht bestätigt",
    "admin.resendVerify": "Bestätigungs-Mail erneut senden",
    "admin.resendWelcome": "Willkommens-Mail erneut senden",
    "admin.mailSent": "E-Mail wurde gesendet",
    "admin.mailFailed": "E-Mail konnte nicht gesendet werden",
    "admin.reporters": "Melder",
    "admin.noReports": "Keine Meldungen.",
    "admin.reportResolved": "Meldung bearbeitet",
    "admin.deleted": "Gelöscht",
    "admin.grantPrompt": "Credits hinzufügen:",
    "dash.avatar": "Profilbild",
    "profile.responseTime": "~1 Std Antwortzeit",
    "role.admin": "Admin",
    "role.craftsman": "Handwerker",
    "role.customer": "Kunde",
    "status.open": "Offen",
    "status.assigned": "Vergeben",
    "status.accepted": "Angenommen",
    "status.completed": "Abgeschlossen",
    "status.disabled": "Deaktiviert",
    "jobs.application": "Angebot",
    "footer.imprint": "Impressum",
    "footer.privacy": "Datenschutz",
    "imprint.title": "Impressum",
    "imprint.body": "Angaben gemäß gesetzlicher Informationspflicht:\n\nMyMoalem – itnetic Group S.A.R.L.\n[Straße & Nr.], [PLZ] [Stadt], Marokko\nHandelsregister (RC): [RC-Nr.] · ICE: [ICE-Nr.]\nE-Mail: contact@mymoalem.com\n\nVerantwortlich für den Inhalt: itnetic Group S.A.R.L.\n\nMyMoalem ist eine reine Vermittlungsplattform. Verträge über Handwerksleistungen kommen ausschließlich zwischen Kunde und Handwerker zustande.",
    "privacy.title": "Datenschutzerklärung",
    "privacy.body": "Datenschutz auf einen Blick:\n\n1. Welche Daten wir erheben: Kontodaten (Name, E-Mail), Profil- und Auftragsdaten, Nachrichten sowie Zahlungsdaten (Banküberweisung – wir speichern keine vollständigen Kartendaten).\n\n2. Zweck: Bereitstellung der Vermittlung zwischen Kunden und Handwerkern, Abwicklung von Lead-Credits und Kommunikation.\n\n3. Weitergabe: Kontaktdaten werden zum Zweck der Vermittlung an die jeweils andere Partei weitergegeben. Zahlungen werden per Banküberweisung abgewickelt.\n\n4. Deine Rechte: Auskunft, Berichtigung und Löschung deiner Daten. Kontakt: contact@mymoalem.com\n\n5. Speicherung: Daten werden nur so lange gespeichert, wie es für die Vermittlung und gesetzliche Pflichten erforderlich ist.",
  },
  fr: {
    "nav.findCraftsmen": "Trouver un artisan",
    "nav.browseJobs": "Voir les missions",
    "nav.postJob": "Publier une mission",
    "nav.dashboard": "Tableau de bord",
    "nav.login": "Connexion",
    "nav.register": "S'inscrire",
    "nav.logout": "Déconnexion",
    "hero.eyebrow": "Artisans locaux, vérifiés et notés",
    "promo.headline": "Offre de lancement : les 200 premiers artisans reçoivent 1 crédit lead gratuit !",
    "promo.only": "Plus que",
    "promo.cta": "J'en profite",
    "hero.title": "Trouvez le bon artisan pour chaque projet",
    "hero.searchPlaceholder": "De quoi avez-vous besoin ?",
    "hero.cityPlaceholder": "Ville",
    "hero.search": "Rechercher",
    "hero.postJob": "Publier une mission — gratuit",
    "categories.title": "Métiers populaires",
    "categories.eyebrow": "Par métier",
    "categories.find": "Trouver des pros",
    "categories.subtitle": "Parcourez les professionnels par spécialité",
    "how.title": "Comment ça marche",
    "how.eyebrow": "En 3 étapes simples",
    "how.subtitle": "De la publication de votre mission au bon professionnel — toujours gratuit pour les clients.",
    "how.freeBadge": "100% gratuit pour les clients",
    "how.step": "Étape",
    "how.cta": "Publier une mission gratuitement",
    "how.s1t": "Décrivez votre projet, gratuitement",
    "how.s1d": "Dites-nous en 2 minutes ce qu'il faut faire – avec photos et lieu. Gratuit et sans engagement.",
    "how.s2t": "Recevez des offres adaptées",
    "how.s2d": "Des artisans vérifiés près de chez vous vous contactent avec leur devis. Vous comparez à votre rythme.",
    "how.s3t": "Engagez en toute confiance",
    "how.s3d": "Consultez avis réels, profils et prix, puis confiez le travail au professionnel qui vous convient.",
    "stats.craftsmen": "Artisans vérifiés",
    "stats.jobs": "Missions réalisées",
    "stats.rating": "Note moyenne",
    "craftsmen.title": "Artisans vérifiés",
    "craftsmen.eyebrow": "Professionnels de confiance",
    "craftsmen.verified": "Vérifié",
    "craftsmen.subtitle": "Des professionnels qualifiés et notés, prêts à aider",
    "craftsmen.allTrades": "Tous les métiers",
    "craftsmen.viewProfile": "Voir le profil",
    "craftsmen.empty": "Aucun artisan ne correspond.",
    "jobs.title": "Missions ouvertes",
    "jobs.subtitle": "Trouvez du travail près de chez vous et envoyez votre offre",
    "jobs.allCategories": "Toutes les catégories",
    "jobs.budget": "Budget",
    "jobs.applications": "offres",
    "jobs.view": "Voir et postuler",
    "jobs.empty": "Aucune mission ouverte pour le moment.",
    "job.description": "Description",
    "job.apply": "Envoyer votre offre",
    "job.yourMessage": "Votre message",
    "job.yourPrice": "Votre prix (DH)",
    "job.submit": "Envoyer l'offre",
    "job.applied": "Offre envoyée !",
    "job.offers": "Offres reçues",
    "job.noOffers": "Aucune offre pour l'instant.",
    "postJob.title": "Publier une nouvelle mission",
    "postJob.jobTitle": "Titre de la mission",
    "postJob.category": "Catégorie",
    "postJob.city": "Ville",
    "postJob.budget": "Budget (DH, optionnel)",
    "postJob.desc": "Décrivez le travail",
    "postJob.photos": "Photos (optionnel)",
    "postJob.photosHint": "Ajoutez des photos du problème pour recevoir des offres précises.",
    "postJob.submit": "Publier la mission",
    "postJob.success": "Votre mission est en ligne !",
    "auth.loginTitle": "Bon retour",
    "auth.registerTitle": "Créez votre compte",
    "auth.name": "Nom complet",
    "auth.email": "E-mail",
    "auth.password": "Mot de passe",
    "auth.role.customer": "Je cherche un artisan",
    "auth.role.craftsman": "Je suis artisan",
    "auth.haveAccount": "Vous avez déjà un compte ?",
    "auth.noAccount": "Pas encore de compte ?",
    "auth.loginBtn": "Connexion",
    "auth.registerBtn": "Créer un compte",
    "auth.emailLang": "Langue des e-mails",
    "auth.emailLangHint": "Nous enverrons tous les e-mails (confirmation, reçus, rappels) dans cette langue.",
    "settings.emailLang": "Langue des e-mails",
    "settings.emailLangHint": "Langue utilisée pour tous les e-mails que nous t'envoyons.",
    "settings.langSaved": "Langue des e-mails mise à jour",
    "auth.forgotPassword": "Mot de passe oublié ?",
    "auth.forgotTitle": "Réinitialiser le mot de passe",
    "auth.forgotDesc": "Saisissez votre e-mail, nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "auth.sendResetLink": "Envoyer le lien",
    "auth.resetSent": "Si un compte existe pour cet e-mail, un lien de réinitialisation a été envoyé. Vérifiez votre boîte de réception.",
    "auth.resetTitle": "Choisir un nouveau mot de passe",
    "auth.newPassword": "Nouveau mot de passe",
    "auth.setNewPassword": "Enregistrer le mot de passe",
    "auth.resetSuccess": "Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.",
    "auth.resetInvalid": "Ce lien est invalide ou expiré. Veuillez en demander un nouveau.",
    "auth.backToLogin": "Retour à la connexion",
    "dash.myJobs": "Mes missions",
    "dash.myApplications": "Mes offres",
    "dash.profile": "Mon profil",
    "dash.noJobs": "Vous n'avez pas encore publié de mission.",
    "dash.noApps": "Vous n'avez pas encore envoyé d'offre.",
    "dash.editProfile": "Modifier le profil",
    "dash.saveProfile": "Enregistrer",
    "dash.trade": "Métier",
    "dash.bio": "Bio",
    "dash.skills": "Compétences (séparées par virgule)",
    "dash.rate": "Tarif horaire (DH)",
    "dash.saved": "Profil enregistré !",
    "profile.reviews": "avis",
    "profile.jobsDone": "missions réalisées",
    "profile.verified": "Vérifié",
    "profile.from": "de",
    "profile.contact": "Contacter l'artisan",
    "profile.contactNote": "Vous ne pouvez pas contacter les artisans directement. Publiez une mission gratuite et des artisans vérifiés vous enverront des offres.",
    "profile.postJobCta": "Publier une mission",
    "footer.tagline": "La place de marché de confiance pour trouver des artisans locaux.",
    "footer.rights": "Tous droits réservés.",
    "common.perHour": "/h",
    "nav.messages": "Messages",
    "nav.admin": "Admin",
    "status.open": "Ouvert",
    "status.assigned": "Attribué",
    "status.completed": "Terminé",
    "dash.acceptOffer": "Accepter l'offre",
    "dash.accepted": "Acceptée",
    "dash.markComplete": "Marquer terminé",
    "dash.leaveReview": "Laisser un avis",
    "dash.reviewed": "Évalué",
    "dash.assignedTo": "Attribué à",
    "dash.message": "Message",
    "review.title": "Évaluer cet artisan",
    "review.comment": "Votre commentaire",
    "review.submit": "Envoyer l'avis",
    "review.success": "Merci pour votre avis !",
    "portfolio.title": "Portfolio",
    "portfolio.upload": "Téléverser des photos",
    "portfolio.uploading": "Téléversement…",
    "chat.title": "Messages",
    "chat.placeholder": "Écrivez un message…",
    "chat.send": "Envoyer",
    "chat.noThreads": "Aucune conversation.",
    "chat.back": "Retour",
    "admin.title": "Panneau admin",
    "admin.users": "Utilisateurs",
    "admin.jobs": "Missions",
    "admin.craftsmen": "Artisans",
    "admin.reviews": "Avis",
    "admin.delete": "Supprimer",
    "admin.verify": "Basculer vérif.",
    "admin.confirmDelete": "Supprimer cet élément ?",
    "nav.map": "Carte",
    "again.title": "Besoin d'autre chose ?",
    "again.sub": "Publiez simplement une nouvelle demande, gratuitement, avec votre ville déjà remplie.",
    "again.same": "Confier une nouvelle mission à cet artisan",
    "again.other": "Chercher un autre métier",
    "again.banner": "Cette demande est envoyée directement à {name}. Les autres artisans ne la voient pas.",
    "inv.title": "Demandes personnelles pour vous",
    "inv.sub": "Des clients satisfaits souhaitent vous confier une nouvelle mission.",
    "inv.view": "Voir la demande",
    "dash.completeTitle": "Terminer la mission et évaluer l'artisan",
    "dash.completeHint": "Votre évaluation est nécessaire pour terminer la mission. Elle aide les autres clients et l'artisan.",
    "dash.completeSubmit": "Évaluer et terminer la mission",
    "dash.pickStars": "Veuillez choisir une note.",
    "dash.doneQ": "Le travail est-il terminé ?",
    "dash.doneHint": "Confirmez la mission, puis vous pourrez évaluer l'artisan. Sans confirmation, elle passe automatiquement à « Terminé » après 30 jours",
    "dash.doneDays": "encore {n} jours",
    "dash.doneToday": "aujourd'hui",
    "dash.doneBtn": "Oui, la mission est terminée",
    "dash.doneConfirm": "Confirmer la mission comme terminée maintenant ?",
    "dash.autoDone": "Terminée automatiquement après 30 jours",
    "prof.name": "Nom",
    "prof.optional": "facultatif",
    "prof.phoneHint": "L'artisan ne voit votre numéro qu'après que vous avez accepté son offre.",
    "prof.customerPhone": "Téléphone du client",
    "prof.save": "Enregistrer",
    "acct.zoneHint": "Vous ne souhaitez plus utiliser MyMoalem ? Ici, vous pouvez supprimer votre compte et vos données personnelles.",
    "acct.delete": "Supprimer le compte",
    "acct.title": "Supprimer définitivement le compte ?",
    "acct.intro": "Cette action est irréversible.",
    "acct.pCustomer": "Vos demandes ouvertes seront retirées. Votre nom et votre e-mail seront supprimés.",
    "acct.pCraftsman": "Votre profil, vos offres ouvertes et votre solde de leads restant seront supprimés. Aucun remboursement.",
    "acct.pLaw": "Nous devons conserver les justificatifs de paiement par obligation légale, mais ils seront dissociés de votre nom.",
    "acct.pActive": "Si une mission est en cours, terminez-la d'abord.",
    "acct.password": "Votre mot de passe pour confirmer",
    "acct.confirm": "Oui, supprimer définitivement",
    "acct.cancel": "Annuler",
    "acct.done": "Votre compte a été supprimé.",
    "acct.zone": "Compte",
    "nav.myProfile": "Mon profil",
    "dash.phone": "Téléphone / WhatsApp",
    "dash.phoneHint": "Affiché uniquement au client qui accepte votre offre. Jamais public.",
    "dash.craftsmanPhone": "Téléphone de l'artisan",
    "dash.offersBanner": "Vous avez reçu des offres – comparez et acceptez maintenant",
    "dash.offersHint": "Comparez prix, note et message et acceptez la bonne offre en un clic.",
    "dash.cheapest": "Prix le plus bas",
    "dash.bestRated": "Mieux noté",
    "dash.viewProfile": "Voir le profil",
    "dash.acceptConfirm": "Accepter cette offre maintenant ? Les autres offres seront refusées.",
    "dash.step1": "Offres",
    "dash.step2": "Artisan choisi",
    "dash.step3": "Terminé",
    "dash.waiting": "Pas encore d'offres. Dès qu'un artisan répond, vous le verrez ici et un chiffre apparaît dans le menu.",
    "dash.jobsDone": "missions réalisées",
    "chat.needsReply": "Réponse attendue",
    "chat.offer": "Offre",
    "chat.newOffer": "Nouvelle offre",
    "guard.hint": "Merci de ne pas indiquer de numéros de téléphone, d'adresses e-mail ou de liens. Le contact passe par MyMoalem – vous échangez vos coordonnées après l'attribution.",
    "guard.hintChat": "Jusqu'à l'attribution de la mission, les numéros de téléphone, e-mails et liens sont interdits dans le chat.",
    "footer.contact": "Contact",
    "contact.title": "Contact et signaler un problème",
    "contact.intro": "Une question, un problème ou une réclamation ? Écrivez-nous – nous répondrons par e-mail dès que possible.",
    "contact.name": "Votre nom",
    "contact.email": "Votre e-mail",
    "contact.topic": "De quoi s'agit-il ?",
    "contact.t.question": "Question",
    "contact.t.problem": "Signaler un problème",
    "contact.t.complaint": "Réclamation",
    "contact.t.other": "Autre",
    "contact.message": "Votre message",
    "contact.messagePh": "Décrivez le plus précisément possible de quoi il s'agit (au moins 10 caractères).",
    "contact.send": "Envoyer le message",
    "contact.thanks": "Merci ! Votre message nous est bien parvenu. Vous recevrez une confirmation par e-mail.",
    "contact.error": "Envoi impossible. Vérifiez vos informations et réessayez plus tard.",
    "val.v1n": "0 MAD",
    "val.v1l": "de frais pour les clients – toujours",
    "val.v2n": "0 %",
    "val.v2l": "de commission sur votre mission",
    "val.v3n": "4 langues",
    "val.v3l": "Deutsch · Français · العربية · English",
    "hero.subtitle": "Publiez votre projet gratuitement et recevez des devis d'artisans locaux vérifiés – sans frais et sans coûts cachés. Vous décidez quelle offre accepter.",
    "nav.postFree": "Publier gratuitement",
    "free.badge": "100 % gratuit pour les clients",
    "free.chip1": "Aucun frais",
    "free.chip2": "Aucun coût caché",
    "free.chip3": "Sans engagement",
    "free.cta": "Publier une mission gratuitement",
    "reg.custTitle": "Réservé aux clients – 100 % gratuit",
    "reg.custBody": "Chacun peut publier ici sa mission et recevoir des offres d'artisans qualifiés. Vous ne payez jamais rien. Ce sont les artisans qui paient pour le contact.",
    "reg.craftTitle": "Pour les artisans",
    "reg.craftBody": "L'inscription est gratuite. Vous ne payez que lorsque vous envoyez une offre : un lead par offre.",
    "postJob.freeInfo": "Gratuit pour vous – aucun frais. Les artisans vous contactent avec leurs offres et vous décidez librement.",
    "fair.custTitle": "Pour les clients",
    "fair.custSub": "Je cherche un artisan",
    "fair.k1t": "Publication gratuite",
    "fair.k1d": "Publier une mission ne vous coûte rien.",
    "fair.k2t": "Suppression jusqu'à la première offre",
    "fair.k2d": "Tant qu'aucun artisan n'a fait d'offre, vous pouvez supprimer votre mission à tout moment.",
    "fair.k3t": "Ensuite, la mission reste",
    "fair.k3d": "Dès qu'un artisan a déjà investi du temps, la mission est conservée. Choisissez simplement l'offre qui vous convient – en cas de problème, nous vous aidons volontiers.",
    "fair.k4t": "Des missions sérieuses",
    "fair.k4d": "Les missions doivent être réelles. Si plusieurs artisans signalent une mission comme non sérieuse, elle est bloquée.",
    "fair.k5t": "Avis après la mission",
    "fair.k5d": "Une fois le travail terminé, vous pouvez noter l'artisan et aider d'autres clients.",
    "fair.craftTitle": "Pour les artisans",
    "fair.craftSub": "Je cherche des missions",
    "fair.h1t": "Inscription gratuite",
    "fair.h1d": "Créer votre profil et consulter les missions ne coûte rien.",
    "fair.h2t": "Une offre = un lead",
    "fair.h2d": "Un lead n'est débité que lorsque vous envoyez une offre. Vous achetez vos leads simplement par virement bancaire.",
    "fair.h3t": "Lead restitué en cas de mission non sérieuse",
    "fair.h3d": "Si au moins deux artisans signalent une mission comme non sérieuse, votre lead vous est restitué.",
    "fair.h4t": "Documenté sans faille",
    "fair.h4d": "Chaque commande et validation de leads est enregistrée avec sa date, pour que tout reste traçable.",
    "fair.h5t": "Des chances équitables",
    "fair.h5d": "Le client décide librement. De bons avis augmentent vos chances d'obtenir d'autres missions.",
    "fair.eyebrow": "Équitable pour les deux parties",
    "fair.title": "Des règles claires pour que chacun puisse compter sur MyMoalem",
    "fair.intro": "Nous voulons que clients et artisans puissent se faire confiance. C'est pourquoi quelques règles simples s'appliquent – expliquées ici brièvement et clairement.",
    "fair.foot": "Ensemble, nous veillons à un échange respectueux – de la première demande jusqu'à la mission terminée.",
    "status.withdrawn": "Retirée",
    "dash.deleteJob": "Supprimer la mission",
    "dash.deleteConfirm": "Voulez-vous vraiment supprimer cette mission ? C'est possible uniquement tant qu'aucun artisan n'a fait d'offre.",
    "dash.jobDeleted": "Mission supprimée",
    "dash.cannotDelete": "Suppression impossible : des artisans ont déjà envoyé des offres. Choisissez une offre ou contactez-nous en cas de problème. Cela protège les artisans qui ont déjà pris du temps pour vous.",
    "dash.deleteHint": "Vous pouvez supprimer cette mission tant qu'aucun artisan n'a fait d'offre.",
    "recruit.title": "À la recherche de missions ?",
    "recruit.sub": "Développez votre activité avec MyMoalem",
    "recruit.body": "MyMoalem vous met en relation avec des clients dans votre ville. Inscrivez-vous gratuitement, consultez les missions près de chez vous et contactez directement les clients – petites ou grandes missions, vous décidez.",
    "recruit.cta": "Inscription gratuite pour artisans",
    "topbar.text": "Vous êtes artisan et cherchez des missions ?",
    "topbar.link": "Inscrivez-vous gratuitement",
    "nav.findJobs": "Trouver des missions",
    "nav.myJobs": "Mes missions",
    "nav.myApps": "Mes candidatures",
    "nav.credits": "Crédits",
    "aud.customerTitle": "Je cherche un artisan",
    "aud.customerLine": "Publiez votre mission gratuitement et recevez des offres",
    "aud.customerBtn": "Publier une mission",
    "aud.c1": "Décrivez votre mission",
    "aud.c2": "Recevez des offres d'artisans",
    "aud.c3": "Choisissez le meilleur",
    "aud.craftTitle": "Je suis artisan",
    "aud.craftLine": "Trouvez des missions dans votre ville et contactez les clients",
    "aud.craftBtn": "Trouver des missions",
    "aud.h1": "Inscrivez-vous gratuitement",
    "aud.h2": "Trouvez les missions adaptées",
    "aud.h3": "Contactez les clients",
    "aud.steps": "Comment ça marche",
    "map.title": "Explorer le Maroc",
    "map.subtitle": "Artisans et missions dans les villes marocaines",
    "map.craftsmen": "Artisans",
    "map.jobs": "Missions",
    "credits.title": "Crédits Lead",
    "credits.balance": "Crédits disponibles",
    "credits.buy": "Acheter des crédits",
    "credits.buyNow": "Acheter des crédits lead",
    "credits.perLead": "1 crédit = 1 contact client (valeur 100 DH)",
    "credits.leads": "leads",
    "credits.history": "Historique des crédits",
    "credits.need": "Vous n'avez plus de crédits. Achetez des crédits pour contacter les clients.",
    "pay.confirming": "Confirmation du paiement…",
    "pay.success": "Paiement réussi !",
    "pay.successMsg": "Vos crédits lead ont été ajoutés à votre compte.",
    "pay.failed": "Impossible de confirmer le paiement. Contactez le support si vous avez été débité.",
    "pay.cancelled": "Paiement annulé. Aucun débit effectué.",
    "pay.toDashboard": "Retour au tableau de bord",
    "admin.credits": "Crédits",
    "admin.orders": "Paiements",
    "admin.confirm": "Confirmer",
    "admin.cancel": "Annuler",
    "admin.noOrders": "Aucune commande de paiement.",
    "credits.pending": "En attente",
    "credits.confirmed": "Confirmé",
    "credits.cancelled": "Annulé",
    "admin.grant": "Créditer",
    "nav.pricing": "Tarifs",
    "pricing.title": "Des tarifs simples pour les artisans",
    "pricing.subtitle": "Les clients publient gratuitement. Les artisans achètent des crédits et dépensent 1 crédit à chaque contact client ou offre envoyée.",
    "pricing.mustBuy": "Pour accepter une mission ou envoyer une offre, l'artisan doit d'abord acheter un pack de crédits.",
    "pricing.cta": "Devenir artisan",
    "pricing.gotoDash": "Acheter des crédits",
    "pricing.popular": "Meilleur prix",
    "pricing.save": "Économisez",
    "pricing.trust1": "Paiement sécurisé par virement",
    "pricing.trust2": "Aucuns frais cachés",
    "legal.badge": "Bon à savoir",
    "legal.title": "Nous mettons uniquement en relation",
    "legal.p1": "MyMoalem est uniquement une plateforme d'intermédiation : nous mettons en relation clients et artisans et transmettons les coordonnées.",
    "legal.p2": "Le contrat pour les travaux est conclu directement et exclusivement entre le client et l'artisan. MyMoalem n'est pas partie au contrat.",
    "legal.p3": "L'exécution, la qualité, les prix, la garantie et toute réclamation relèvent de la seule responsabilité du client et de l'artisan, qui les règlent directement entre eux.",
    "legal.p4": "MyMoalem décline toute responsabilité quant aux missions conclues ou à leur réalisation.",
    "legal.pageTitle": "Conditions & Mentions légales",
    "footer.pricing": "Tarifs",
    "footer.legal": "Mentions légales & CGU",
    "apply.cost": "Ce contact coûte 1 crédit lead.",
    "apply.ack": "Je comprends qu'1 crédit sera utilisé et que MyMoalem ne fait que mettre en relation. Le contrat et toute réclamation relèvent uniquement de moi et du client.",
    "auth.acceptTerms": "J'accepte les CGU et la Politique de confidentialité.",
    "verify.sentTitle": "Vérifie ta boîte mail",
    "verify.sentMsg": "Nous avons envoyé un lien de confirmation à",
    "verify.loading": "Confirmation de ton e-mail…",
    "verify.okTitle": "E-mail confirmé !",
    "verify.okMsg": "Ton compte est maintenant actif.",
    "verify.goDashboard": "Aller au tableau de bord",
    "verify.errTitle": "Lien invalide ou expiré",
    "verify.errMsg": "Ce lien de confirmation est invalide ou a déjà été utilisé.",
    "verify.needVerify": "Confirme d'abord ton adresse e-mail. Vérifie ta boîte mail.",
    "verify.resend": "Renvoyer l'e-mail de confirmation",
    "verify.resent": "E-mail de confirmation envoyé.",
    "report.button": "Signaler comme faux",
    "report.title": "Signaler cette mission",
    "report.desc": "Ne signalez que les missions que vous jugez fausses ou trompeuses. Si confirmé, votre crédit est remboursé.",
    "report.placeholder": "Quel est le problème avec cette mission ? (optionnel)",
    "report.submit": "Envoyer le signalement",
    "report.cancel": "Annuler",
    "report.received": "Signalement reçu. Notre équipe va l'examiner.",
    "report.autoConfirmed": "Cette mission a été signalée comme fausse. Votre crédit a été remboursé.",
    "report.done": "Signalé",
    "trust.title": "À propos de ce client",
    "trust.verified": "Client de confiance",
    "trust.new": "Nouveau client",
    "trust.flagged": "Client signalé",
    "trust.jobsPosted": "missions publiées",
    "trust.memberSince": "Membre depuis",
    "trust.hint": "Conseil : avant de dépenser un crédit, vérifiez les informations du client — membre depuis, missions publiées et statut de confiance. Soyez prudent avec les clients tout nouveaux ou signalés.",
    "admin.reports": "Signalements",
    "admin.confirmFake": "Confirmer faux & rembourser",
    "admin.dismiss": "Rejeter",
    "admin.sevDisable": "Désactiver la mission seulement",
    "admin.sevFlag": "Désactiver + signaler le client",
    "admin.sevBlock": "Désactiver + bloquer le client",
    "admin.flagged": "Signalé",
    "admin.blocked": "Bloqué",
    "admin.block": "Bloquer",
    "admin.unblock": "Débloquer",
    "admin.leadBought": "Achetés",
    "admin.leadFree": "Gratuits",
    "admin.leadUsed": "Utilisés",
    "admin.leadActive": "Actifs",
    "admin.leadLow": "Limite bientôt atteinte",
    "admin.remind": "Envoyer un rappel de recharge",
    "admin.unverified": "E-mail non confirmé",
    "admin.resendVerify": "Renvoyer l'e-mail de confirmation",
    "admin.resendWelcome": "Renvoyer l'e-mail de bienvenue",
    "admin.mailSent": "E-mail envoyé",
    "admin.mailFailed": "L'e-mail n'a pas pu être envoyé",
    "admin.reporters": "signalements",
    "admin.noReports": "Aucun signalement.",
    "admin.reportResolved": "Signalement traité",
    "admin.deleted": "Supprimé",
    "admin.grantPrompt": "Crédits à ajouter :",
    "dash.avatar": "Photo de profil",
    "profile.responseTime": "réponse en ~1h",
    "role.admin": "Admin",
    "role.craftsman": "Artisan",
    "role.customer": "Client",
    "status.open": "Ouvert",
    "status.assigned": "Attribué",
    "status.accepted": "Accepté",
    "status.completed": "Terminé",
    "status.disabled": "Désactivé",
    "jobs.application": "offre",
    "footer.imprint": "Mentions légales",
    "footer.privacy": "Confidentialité",
    "imprint.title": "Mentions légales",
    "imprint.body": "Informations conformément aux obligations légales :\n\nMyMoalem – itnetic Group S.A.R.L.\n[Rue & N°], [Code postal] [Ville], Maroc\nRegistre du commerce (RC) : [N° RC] · ICE : [N° ICE]\nE-mail : contact@mymoalem.com\n\nResponsable du contenu : itnetic Group S.A.R.L.\n\nMyMoalem est uniquement une plateforme d'intermédiation. Les contrats pour les services d'artisans sont conclus exclusivement entre le client et l'artisan.",
    "privacy.title": "Politique de confidentialité",
    "privacy.body": "La confidentialité en bref :\n\n1. Données collectées : données de compte (nom, e-mail), données de profil et de mission, messages, et données de paiement (virement bancaire – nous ne stockons pas les détails complets des cartes).\n\n2. Finalité : assurer la mise en relation entre clients et artisans, la gestion des crédits lead et la communication.\n\n3. Partage : les coordonnées sont transmises à l'autre partie aux fins de mise en relation. Les paiements sont traités par virement bancaire.\n\n4. Vos droits : accès, rectification et suppression de vos données. Contact : contact@mymoalem.com\n\n5. Conservation : les données ne sont conservées que le temps nécessaire à la mise en relation et aux obligations légales.",
  },
  ar: {
    "nav.findCraftsmen": "البحث عن حرفيين",
    "nav.browseJobs": "تصفح الأعمال",
    "nav.postJob": "نشر عمل",
    "nav.dashboard": "لوحة التحكم",
    "nav.login": "تسجيل الدخول",
    "nav.register": "إنشاء حساب",
    "nav.logout": "تسجيل الخروج",
    "nav.messages": "الرسائل",
    "nav.admin": "الإدارة",
    "nav.map": "الخريطة",
    "again.title": "هل تحتاج شيئاً آخر؟",
    "again.sub": "أضف طلباً جديداً مجاناً، ومدينتك مكتوبة مسبقاً.",
    "again.same": "التعاقد مع هذا الحرفي مجدداً",
    "again.other": "ابحث عن مهنة أخرى",
    "again.banner": "يُرسل هذا الطلب مباشرة إلى {name}. لا يراه الحرفيون الآخرون.",
    "inv.title": "طلبات شخصية لك",
    "inv.sub": "عملاء راضون عن عملك يريدون التعاقد معك مجدداً.",
    "inv.view": "عرض الطلب",
    "dash.completeTitle": "إنهاء العمل وتقييم الحرفي",
    "dash.completeHint": "نحتاج تقييمك لإنهاء العمل. فهو يساعد العملاء الآخرين والحرفي.",
    "dash.completeSubmit": "قيّم وأنهِ العمل",
    "dash.pickStars": "يرجى اختيار عدد النجوم.",
    "dash.doneQ": "هل انتهى العمل؟",
    "dash.doneHint": "أكّد العمل ثم قيّم الحرفي. بدون تأكيد يصبح تلقائياً «منجز» بعد 30 يوماً",
    "dash.doneDays": "متبقي {n} يوماً",
    "dash.doneToday": "اليوم",
    "dash.doneBtn": "نعم، تم إنجاز العمل",
    "dash.doneConfirm": "تأكيد إنجاز العمل الآن؟",
    "dash.autoDone": "أُنجز تلقائياً بعد 30 يوماً",
    "prof.name": "الاسم",
    "prof.optional": "اختياري",
    "prof.phoneHint": "لا يرى الحرفي رقمك إلا بعد قبولك لعرضه.",
    "prof.customerPhone": "هاتف العميل",
    "prof.save": "حفظ",
    "acct.zoneHint": "لا ترغب في استخدام MyMoalem بعد الآن؟ يمكنك هنا حذف حسابك وبياناتك الشخصية.",
    "acct.delete": "حذف الحساب",
    "acct.title": "حذف الحساب نهائياً؟",
    "acct.intro": "لا يمكن التراجع عن هذا الإجراء.",
    "acct.pCustomer": "سيتم سحب طلباتك المفتوحة وإزالة اسمك وبريدك الإلكتروني.",
    "acct.pCraftsman": "سيتم حذف ملفك وعروضك المفتوحة ورصيد الطلبات المتبقي. لا يوجد استرداد.",
    "acct.pLaw": "يجب علينا الاحتفاظ بسجلات الدفع قانونياً، لكنها ستنفصل عن اسمك.",
    "acct.pActive": "إذا كان لديك عمل جارٍ فأنهِه أولاً.",
    "acct.password": "كلمة المرور للتأكيد",
    "acct.confirm": "نعم، احذف الحساب نهائياً",
    "acct.cancel": "إلغاء",
    "acct.done": "تم حذف حسابك.",
    "acct.zone": "الحساب",
    "nav.myProfile": "ملفي الشخصي",
    "dash.phone": "الهاتف / واتساب",
    "dash.phoneHint": "يظهر فقط للعميل الذي يقبل عرضك. لا يظهر للعموم أبداً.",
    "dash.craftsmanPhone": "هاتف الحرفي",
    "dash.offersBanner": "وصلتك عروض – قارن واقبل الآن",
    "dash.offersHint": "قارن السعر والتقييم والرسالة واقبل العرض المناسب بنقرة واحدة.",
    "dash.cheapest": "الأقل سعراً",
    "dash.bestRated": "الأعلى تقييماً",
    "dash.viewProfile": "عرض الملف",
    "dash.acceptConfirm": "قبول هذا العرض الآن؟ سيتم رفض العروض الأخرى.",
    "dash.step1": "العروض",
    "dash.step2": "تم اختيار الحرفي",
    "dash.step3": "منجز",
    "dash.waiting": "لا توجد عروض بعد. بمجرد أن يرد حرفي ستراه هنا وسيظهر رقم في القائمة.",
    "dash.jobsDone": "أعمال منجزة",
    "chat.needsReply": "بانتظار ردك",
    "chat.offer": "عرض",
    "chat.newOffer": "عرض جديد",
    "guard.hint": "يرجى عدم كتابة أرقام الهاتف أو عناوين البريد الإلكتروني أو الروابط. التواصل يتم عبر MyMoalem – وتتبادلون البيانات بعد إسناد العمل.",
    "guard.hintChat": "إلى حين إسناد العمل، يُمنع كتابة أرقام الهاتف والبريد الإلكتروني والروابط في المحادثة.",
    "footer.contact": "اتصل بنا",
    "contact.title": "اتصل بنا والإبلاغ عن مشكلة",
    "contact.intro": "لديك سؤال أو مشكلة أو شكوى؟ اكتب لنا – سنرد عليك بالبريد الإلكتروني في أقرب وقت ممكن.",
    "contact.name": "اسمك",
    "contact.email": "بريدك الإلكتروني",
    "contact.topic": "ما الموضوع؟",
    "contact.t.question": "سؤال",
    "contact.t.problem": "الإبلاغ عن مشكلة",
    "contact.t.complaint": "شكوى",
    "contact.t.other": "أخرى",
    "contact.message": "رسالتك",
    "contact.messagePh": "يرجى وصف الموضوع بأكبر قدر من الدقة (10 أحرف على الأقل).",
    "contact.send": "إرسال الرسالة",
    "contact.thanks": "شكراً! وصلتنا رسالتك. ستتلقى تأكيداً عبر البريد الإلكتروني.",
    "contact.error": "تعذر الإرسال. تحقق من بياناتك وحاول لاحقاً.",
    "val.v1n": "0 درهم",
    "val.v1l": "تكلفة على الزبناء – دائماً",
    "val.v2n": "0%",
    "val.v2l": "عمولة على طلبك",
    "val.v3n": "4 لغات",
    "val.v3l": "Deutsch · Français · العربية · English",
    "hero.subtitle": "انشر مشروعك مجاناً واحصل على عروض من حرفيين محليين موثوقين – دون رسوم ودون تكاليف خفية. أنت من يقرر أي عرض تقبل.",
    "nav.postFree": "انشر طلبك مجانًا",
    "free.badge": "مجاني 100% للزبناء",
    "free.chip1": "بدون رسوم",
    "free.chip2": "بدون تكاليف خفية",
    "free.chip3": "دون التزام",
    "free.cta": "انشر طلبك مجانًا",
    "reg.custTitle": "للزبناء فقط – مجاني 100%",
    "reg.custBody": "يمكن لكل شخص هنا نشر طلبه واستقبال عروض من حرفيين مؤهلين. لن تدفع أي شيء أبدًا. الحرفيون هم من يدفعون مقابل التواصل.",
    "reg.craftTitle": "للحرفيين",
    "reg.craftBody": "التسجيل مجاني. تدفع فقط عند تقديم عرض: رصيد واحد لكل عرض.",
    "postJob.freeInfo": "مجاني لك – دون رسوم. يتواصل معك الحرفيون بعروضهم وأنت تقرر بحرية.",
    "fair.custTitle": "للزبناء",
    "fair.custSub": "أبحث عن حرفي",
    "fair.k1t": "النشر مجاني",
    "fair.k1d": "نشر الطلب لا يكلّفك شيئًا.",
    "fair.k2t": "الحذف حتى أول عرض",
    "fair.k2d": "ما دام لم يقدّم أي حرفي عرضًا، يمكنك حذف طلبك في أي وقت.",
    "fair.k3t": "بعد ذلك يبقى الطلب",
    "fair.k3d": "إذا كان حرفي قد خصّص وقته بالفعل، يبقى الطلب قائمًا. اختر ببساطة العرض المناسب، وإذا واجهتك مشكلة فسنساعدك بكل سرور.",
    "fair.k4t": "طلبات جادة فقط",
    "fair.k4d": "يجب أن تكون الطلبات حقيقية. إذا أبلغ عدة حرفيين عن طلب غير جاد فسيتم حظره.",
    "fair.k5t": "التقييم بعد الإنجاز",
    "fair.k5d": "بعد إنجاز العمل يمكنك تقييم الحرفي ومساعدة زبناء آخرين.",
    "fair.craftTitle": "للحرفيين",
    "fair.craftSub": "أبحث عن أعمال",
    "fair.h1t": "التسجيل مجاني",
    "fair.h1d": "إنشاء ملفك الشخصي وتصفح الأعمال لا يكلّفك شيئًا.",
    "fair.h2t": "عرض واحد = رصيد واحد",
    "fair.h2d": "يُخصم رصيد واحد فقط عند تقديم عرض. تشتري رصيدك بسهولة عبر التحويل البنكي.",
    "fair.h3t": "استرجاع الرصيد عند الطلبات غير الجادة",
    "fair.h3d": "إذا أبلغ حرفيان على الأقل عن طلب غير جاد، يُعاد إليك رصيدك.",
    "fair.h4t": "توثيق كامل",
    "fair.h4d": "كل طلب وموافقة على الرصيد يُسجَّل بتاريخه ليبقى كل شيء قابلًا للتتبع.",
    "fair.h5t": "فرص عادلة",
    "fair.h5d": "الزبون يقرر بحرية. التقييمات الجيدة تزيد فرصك في الحصول على أعمال أخرى.",
    "fair.eyebrow": "منصف للطرفين",
    "fair.title": "قواعد واضحة ليعتمد الجميع على MyMoalem",
    "fair.intro": "نريد أن يثق الزبناء والحرفيون ببعضهم. لذلك تُطبَّق بضع قواعد بسيطة نشرحها هنا باختصار ووضوح.",
    "fair.foot": "معًا نضمن تعاملًا محترمًا – من الطلب الأول حتى إنجاز العمل.",
    "status.withdrawn": "مسحوب",
    "dash.deleteJob": "حذف الطلب",
    "dash.deleteConfirm": "هل تريد حقًا حذف هذا الطلب؟ هذا ممكن فقط ما دام لم يقدّم أي حرفي عرضًا.",
    "dash.jobDeleted": "تم حذف الطلب",
    "dash.cannotDelete": "لم يعد الحذف ممكنًا: لقد وصلت عروض من حرفيين. اختر عرضًا أو تواصل معنا إذا كان هناك خطأ. هذا يحمي الحرفيين الذين خصصوا وقتهم لك.",
    "dash.deleteHint": "يمكنك حذف هذا الطلب ما دام لم يقدّم أي حرفي عرضًا.",
    "recruit.title": "تبحث عن أعمال؟",
    "recruit.sub": "طوّر نشاطك مع MyMoalem",
    "recruit.body": "يربطك MyMoalem بزبناء في مدينتك. سجّل مجانًا، واطّلع على الأعمال المناسبة بالقرب منك وتواصل مع الزبناء مباشرة – أعمال صغيرة أو كبيرة، القرار لك.",
    "recruit.cta": "تسجيل مجاني للحرفيين",
    "topbar.text": "هل أنت حرفي وتبحث عن أعمال؟",
    "topbar.link": "سجّل مجانًا",
    "nav.findJobs": "ابحث عن أعمال",
    "nav.myJobs": "طلباتي",
    "nav.myApps": "عروضي",
    "nav.credits": "الرصيد",
    "aud.customerTitle": "أبحث عن حرفي",
    "aud.customerLine": "انشر طلبك مجانًا واستقبل العروض",
    "aud.customerBtn": "انشر طلبك",
    "aud.c1": "صف عملك",
    "aud.c2": "استقبل عروض الحرفيين",
    "aud.c3": "اختر الأفضل",
    "aud.craftTitle": "أنا حرفي",
    "aud.craftLine": "اعثر على أعمال في مدينتك وتواصل مع الزبناء",
    "aud.craftBtn": "ابحث عن أعمال",
    "aud.h1": "سجّل مجانًا",
    "aud.h2": "اعثر على الأعمال المناسبة",
    "aud.h3": "تواصل مع الزبناء",
    "aud.steps": "كيف يعمل",
    "hero.eyebrow": "حرفيون محليون، موثوقون ومقيّمون",
    "promo.headline": "عرض الإطلاق: أول 200 حرفي يحصلون على رصيد ليد مجاني!",
    "promo.only": "بقي فقط",
    "promo.cta": "احصل عليه الآن",
    "hero.title": "اعثر على الحرفي المناسب لكل عمل",
    "hero.searchPlaceholder": "ما الذي تحتاج إنجازه؟",
    "hero.cityPlaceholder": "المدينة",
    "hero.search": "بحث",
    "hero.postJob": "انشر عملاً — مجاناً",
    "categories.title": "المهن الشائعة",
    "categories.eyebrow": "حسب المهنة",
    "categories.find": "ابحث عن محترفين",
    "categories.subtitle": "تصفح المحترفين حسب التخصص",
    "how.title": "كيف يعمل",
    "how.eyebrow": "في 3 خطوات بسيطة",
    "how.subtitle": "من نشر طلبك حتى اختيار المحترف المناسب — مجاني دائماً للعملاء.",
    "how.freeBadge": "مجاني 100% للعملاء",
    "how.step": "الخطوة",
    "how.cta": "انشر طلبك مجاناً",
    "how.s1t": "صف عملك مجاناً",
    "how.s1d": "أخبرنا خلال دقيقتين بما تريد إنجازه – مع الصور والموقع. مجاناً وبدون التزام.",
    "how.s2t": "استقبل عروضاً مناسبة",
    "how.s2d": "يتواصل معك حرفيون موثوقون بالقرب منك ويرسلون عروضهم. تقارن على راحتك.",
    "how.s3t": "وظّف بثقة",
    "how.s3d": "اطّلع على التقييمات الحقيقية والملفات والأسعار، ثم وظّف المحترف الأنسب لك.",
    "stats.craftsmen": "حرفيون موثوقون",
    "stats.jobs": "أعمال منجزة",
    "stats.rating": "متوسط التقييم",
    "craftsmen.title": "حرفيون موثوقون",
    "craftsmen.eyebrow": "محترفون موثوقون",
    "craftsmen.verified": "موثّق",
    "craftsmen.subtitle": "محترفون مؤهلون ومقيّمون جاهزون للمساعدة",
    "craftsmen.allTrades": "كل المهن",
    "craftsmen.viewProfile": "عرض الملف",
    "craftsmen.empty": "لا يوجد حرفيون مطابقون لبحثك.",
    "jobs.title": "أعمال مفتوحة",
    "jobs.subtitle": "اعثر على عمل قريب منك وأرسل عرضك",
    "jobs.allCategories": "كل الفئات",
    "jobs.budget": "الميزانية",
    "jobs.applications": "عروض",
    "jobs.view": "عرض وتقديم",
    "jobs.empty": "لا توجد أعمال مفتوحة حالياً.",
    "job.description": "الوصف",
    "job.apply": "أرسل عرضك",
    "job.yourMessage": "رسالتك",
    "job.yourPrice": "سعرك (د.م.)",
    "job.submit": "إرسال العرض",
    "job.applied": "تم إرسال العرض!",
    "job.offers": "العروض المستلمة",
    "job.noOffers": "لا توجد عروض بعد.",
    "postJob.title": "نشر عمل جديد",
    "postJob.jobTitle": "عنوان العمل",
    "postJob.category": "الفئة",
    "postJob.city": "المدينة",
    "postJob.budget": "الميزانية (د.م.، اختياري)",
    "postJob.desc": "صف العمل",
    "postJob.photos": "صور (اختياري)",
    "postJob.photosHint": "أضف صوراً للمشكلة ليتمكن الحرفيون من تقديم عروض دقيقة.",
    "postJob.submit": "نشر العمل",
    "postJob.success": "عملك أصبح منشوراً!",
    "auth.loginTitle": "مرحباً بعودتك",
    "auth.registerTitle": "أنشئ حسابك",
    "auth.name": "الاسم الكامل",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.role.customer": "أبحث عن حرفي",
    "auth.role.craftsman": "أنا حرفي",
    "auth.haveAccount": "لديك حساب بالفعل؟",
    "auth.noAccount": "ليس لديك حساب؟",
    "auth.loginBtn": "تسجيل الدخول",
    "auth.registerBtn": "إنشاء حساب",
    "auth.emailLang": "لغة البريد الإلكتروني",
    "auth.emailLangHint": "سنرسل جميع رسائل البريد الإلكتروني (التأكيد، الإيصالات، التذكيرات) بهذه اللغة.",
    "settings.emailLang": "لغة البريد الإلكتروني",
    "settings.emailLangHint": "اللغة المستخدمة لجميع رسائل البريد الإلكتروني التي نرسلها إليك.",
    "settings.langSaved": "تم تحديث لغة البريد الإلكتروني",
    "auth.forgotPassword": "نسيت كلمة المرور؟",
    "auth.forgotTitle": "إعادة تعيين كلمة المرور",
    "auth.forgotDesc": "أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.",
    "auth.sendResetLink": "إرسال الرابط",
    "auth.resetSent": "إذا كان هناك حساب بهذا البريد، فقد أُرسل رابط إعادة التعيين. يرجى التحقق من بريدك.",
    "auth.resetTitle": "اختر كلمة مرور جديدة",
    "auth.newPassword": "كلمة المرور الجديدة",
    "auth.setNewPassword": "حفظ كلمة المرور",
    "auth.resetSuccess": "تمت إعادة تعيين كلمة المرور. يمكنك الآن تسجيل الدخول.",
    "auth.resetInvalid": "هذا الرابط غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.",
    "auth.backToLogin": "العودة إلى تسجيل الدخول",
    "dash.myJobs": "أعمالي",
    "dash.myApplications": "عروضي",
    "dash.profile": "ملفي الشخصي",
    "dash.noJobs": "لم تنشر أي عمل بعد.",
    "dash.noApps": "لم ترسل أي عرض بعد.",
    "dash.editProfile": "تعديل الملف",
    "dash.saveProfile": "حفظ الملف",
    "dash.trade": "المهنة",
    "dash.bio": "نبذة",
    "dash.skills": "المهارات (مفصولة بفاصلة)",
    "dash.rate": "الأجر بالساعة (د.م.)",
    "dash.saved": "تم حفظ الملف!",
    "profile.reviews": "تقييمات",
    "profile.jobsDone": "أعمال منجزة",
    "profile.verified": "موثوق",
    "profile.from": "من",
    "profile.contact": "مراسلة الحرفي",
    "profile.contactNote": "لا يمكنك مراسلة الحرفيين مباشرةً. انشر طلباً مجاناً وسيرسل لك حرفيون موثوقون عروضهم.",
    "profile.postJobCta": "انشر طلباً",
    "footer.tagline": "المنصة الموثوقة التي تربطك بحرفيين محليين ماهرين في المغرب.",
    "footer.rights": "جميع الحقوق محفوظة.",
    "common.perHour": "/ساعة",
    "status.open": "مفتوح",
    "status.assigned": "مُسند",
    "status.completed": "منجز",
    "dash.acceptOffer": "قبول العرض",
    "dash.accepted": "مقبول",
    "dash.markComplete": "وضع كمنجز",
    "dash.leaveReview": "أضف تقييماً",
    "dash.reviewed": "تم التقييم",
    "dash.assignedTo": "مُسند إلى",
    "dash.message": "رسالة",
    "review.title": "قيّم هذا الحرفي",
    "review.comment": "تعليقك",
    "review.submit": "إرسال التقييم",
    "review.success": "شكراً على تقييمك!",
    "portfolio.title": "معرض الأعمال",
    "portfolio.upload": "رفع صور",
    "portfolio.uploading": "جارٍ الرفع…",
    "chat.title": "الرسائل",
    "chat.placeholder": "اكتب رسالة…",
    "chat.send": "إرسال",
    "chat.noThreads": "لا توجد محادثات بعد.",
    "chat.back": "رجوع",
    "admin.title": "لوحة الإدارة",
    "admin.users": "المستخدمون",
    "admin.jobs": "الأعمال",
    "admin.craftsmen": "الحرفيون",
    "admin.reviews": "التقييمات",
    "admin.delete": "حذف",
    "admin.verify": "تبديل التوثيق",
    "admin.confirmDelete": "حذف هذا العنصر؟",
    "map.title": "استكشف المغرب",
    "map.subtitle": "حرفيون وأعمال في المدن المغربية",
    "map.craftsmen": "حرفيون",
    "map.jobs": "أعمال",
    "credits.title": "رصيد العملاء (ليدز)",
    "credits.balance": "الرصيد المتاح",
    "credits.buy": "شراء رصيد",
    "credits.buyNow": "شراء رصيد ليدز",
    "credits.perLead": "رصيد واحد = تواصل مع عميل (بقيمة 100 د.م.)",
    "credits.leads": "ليدز",
    "credits.history": "سجل الرصيد",
    "credits.need": "لا يوجد لديك رصيد. اشترِ رصيداً للتواصل مع العملاء.",
    "pay.confirming": "جارٍ تأكيد الدفع…",
    "pay.success": "تم الدفع بنجاح!",
    "pay.successMsg": "تمت إضافة الرصيد إلى حسابك.",
    "pay.failed": "تعذّر تأكيد الدفع. تواصل مع الدعم إذا تم خصم المبلغ.",
    "pay.cancelled": "تم إلغاء الدفع. لم يتم خصم أي مبلغ.",
    "pay.toDashboard": "العودة إلى لوحة التحكم",
    "admin.credits": "الرصيد",
    "admin.orders": "المدفوعات",
    "admin.confirm": "تأكيد",
    "admin.cancel": "إلغاء",
    "admin.noOrders": "لا توجد طلبات دفع بعد.",
    "credits.pending": "قيد الانتظار",
    "credits.confirmed": "مؤكد",
    "credits.cancelled": "ملغى",
    "admin.grant": "إضافة",
    "nav.pricing": "الأسعار",
    "pricing.title": "أسعار بسيطة للحرفيين",
    "pricing.subtitle": "ينشر العملاء الأعمال مجاناً. يشتري الحرفيون رصيداً ويُخصم رصيد واحد عند كل تواصل مع عميل أو إرسال عرض.",
    "pricing.mustBuy": "لقبول عمل أو إرسال عرض، يجب على الحرفي أولاً شراء باقة رصيد.",
    "pricing.cta": "ابدأ كحرفي",
    "pricing.gotoDash": "شراء رصيد",
    "pricing.popular": "أفضل قيمة",
    "pricing.save": "وفّر",
    "pricing.trust1": "دفع آمن عبر التحويل البنكي",
    "pricing.trust2": "بدون رسوم خفية",
    "legal.badge": "معلومة مهمة",
    "legal.title": "نحن نتوسّط في التواصل فقط",
    "legal.p1": "MyMoalem منصة وساطة فقط: نربط بين العملاء والحرفيين ونمرّر بيانات التواصل.",
    "legal.p2": "يُبرَم عقد العمل مباشرةً وحصراً بين العميل والحرفي. MyMoalem ليست طرفاً في العقد.",
    "legal.p3": "التنفيذ والجودة والأسعار والضمان وأي شكاوى هي مسؤولية العميل والحرفي وحدهما ويتم تسويتها مباشرةً بينهما.",
    "legal.p4": "لا تتحمّل MyMoalem أي مسؤولية عن الأعمال المُبرمة أو عن تنفيذها.",
    "legal.pageTitle": "الشروط والإشعار القانوني",
    "footer.pricing": "الأسعار",
    "footer.legal": "القانونية والشروط",
    "apply.cost": "هذا التواصل يكلّف رصيداً واحداً.",
    "apply.ack": "أفهم أنه سيتم خصم رصيد واحد وأن MyMoalem تتوسّط في التواصل فقط. العقد وأي شكاوى تكون حصراً بيني وبين العميل.",
    "auth.acceptTerms": "أوافق على الشروط وسياسة الخصوصية.",
    "verify.sentTitle": "تحقّق من بريدك",
    "verify.sentMsg": "أرسلنا رابط تأكيد إلى",
    "verify.loading": "جارٍ تأكيد بريدك…",
    "verify.okTitle": "تم تأكيد البريد!",
    "verify.okMsg": "أصبح حسابك مُفعّلاً الآن.",
    "verify.goDashboard": "إلى لوحة التحكم",
    "verify.errTitle": "الرابط غير صالح أو منتهٍ",
    "verify.errMsg": "رابط التأكيد غير صالح أو تم استخدامه من قبل.",
    "verify.needVerify": "يرجى تأكيد بريدك الإلكتروني أولاً. تحقّق من بريدك.",
    "verify.resend": "إعادة إرسال بريد التأكيد",
    "verify.resent": "تم إرسال بريد التأكيد.",
    "report.button": "الإبلاغ كإعلان مزيف",
    "report.title": "الإبلاغ عن هذا العمل",
    "report.desc": "أبلغ فقط عن الأعمال التي تعتقد أنها مزيفة أو مضللة. عند التأكيد يُعاد رصيدك.",
    "report.placeholder": "ما المشكلة في هذا العمل؟ (اختياري)",
    "report.submit": "إرسال البلاغ",
    "report.cancel": "إلغاء",
    "report.received": "تم استلام البلاغ. سيراجعه فريقنا.",
    "report.autoConfirmed": "تم تصنيف هذا العمل كمزيف. تم إرجاع رصيدك.",
    "report.done": "تم الإبلاغ",
    "trust.title": "عن هذا العميل",
    "trust.verified": "عميل موثوق",
    "trust.new": "عميل جديد",
    "trust.flagged": "عميل مُبلَّغ عنه",
    "trust.jobsPosted": "أعمال منشورة",
    "trust.memberSince": "عضو منذ",
    "trust.hint": "نصيحة: قبل استخدام رصيدك، انتبه إلى معلومات العميل — عضو منذ، الأعمال المنشورة وحالة الثقة. كن حذراً مع العملاء الجدد تماماً أو المُبلَّغ عنهم.",
    "admin.reports": "البلاغات",
    "admin.confirmFake": "تأكيد التزييف والإرجاع",
    "admin.dismiss": "رفض",
    "admin.sevDisable": "تعطيل العمل فقط",
    "admin.sevFlag": "تعطيل + تمييز العميل",
    "admin.sevBlock": "تعطيل + حظر العميل",
    "admin.flagged": "مميّز",
    "admin.blocked": "محظور",
    "admin.block": "حظر",
    "admin.unblock": "إلغاء الحظر",
    "admin.leadBought": "المشتراة",
    "admin.leadFree": "المجانية",
    "admin.leadUsed": "المستخدمة",
    "admin.leadActive": "النشطة",
    "admin.leadLow": "على وشك النفاد",
    "admin.remind": "إرسال تذكير بإعادة الشحن",
    "admin.unverified": "البريد الإلكتروني غير مؤكد",
    "admin.resendVerify": "إعادة إرسال رسالة التأكيد",
    "admin.resendWelcome": "إعادة إرسال رسالة الترحيب",
    "admin.mailSent": "تم إرسال الرسالة",
    "admin.mailFailed": "تعذر إرسال الرسالة",
    "admin.reporters": "مُبلِّغون",
    "admin.noReports": "لا توجد بلاغات.",
    "admin.reportResolved": "تمت معالجة البلاغ",
    "admin.deleted": "تم الحذف",
    "admin.grantPrompt": "عدد الأرصدة المضافة:",
    "dash.avatar": "الصورة الرمزية",
    "profile.responseTime": "الرد خلال ~ساعة",
    "role.admin": "مدير",
    "role.craftsman": "حرفي",
    "role.customer": "عميل",
    "status.open": "مفتوح",
    "status.assigned": "معيَّن",
    "status.accepted": "مقبول",
    "status.completed": "مكتمل",
    "status.disabled": "معطّل",
    "jobs.application": "عرض",
    "footer.imprint": "بيانات الناشر",
    "footer.privacy": "الخصوصية",
    "imprint.title": "بيانات الناشر",
    "imprint.body": "معلومات وفقاً للالتزامات القانونية:\n\nMyMoalem – itnetic Group S.A.R.L.\n[الشارع ورقمه]، [الرمز البريدي] [المدينة]، المغرب\nالسجل التجاري (RC): [رقم RC] · ICE: [رقم ICE]\nالبريد الإلكتروني: contact@mymoalem.com\n\nالمسؤول عن المحتوى: itnetic Group S.A.R.L.\n\nMyMoalem منصة وساطة فقط. تُبرَم عقود خدمات الحرفيين حصراً بين العميل والحرفي.",
    "privacy.title": "سياسة الخصوصية",
    "privacy.body": "الخصوصية باختصار:\n\n1. البيانات التي نجمعها: بيانات الحساب (الاسم، البريد الإلكتروني)، بيانات الملف والأعمال، الرسائل، وبيانات الدفع (التحويل البنكي – لا نخزّن بيانات البطاقة الكاملة).\n\n2. الغرض: توفير الوساطة بين العملاء والحرفيين، وإدارة رصيد الليدز والتواصل.\n\n3. المشاركة: تُمرَّر بيانات التواصل إلى الطرف الآخر لغرض الوساطة. تُعالَج المدفوعات عبر التحويل البنكي.\n\n4. حقوقك: الاطلاع على بياناتك وتصحيحها وحذفها. للتواصل: contact@mymoalem.com\n\n5. الاحتفاظ: تُحفَظ البيانات فقط للمدة اللازمة للوساطة والالتزامات القانونية.",
  },
};

const catNames = {
  carpentry: { en: "Carpentry", de: "Tischlerei", fr: "Menuiserie", ar: "نجارة" },
  plumbing: { en: "Plumbing", de: "Klempnerei", fr: "Plomberie", ar: "سباكة" },
  electrical: { en: "Electrical", de: "Elektrik", fr: "Électricité", ar: "كهرباء" },
  painting: { en: "Painting", de: "Malerei", fr: "Peinture", ar: "دهان" },
  roofing: { en: "Roofing", de: "Dachdeckerei", fr: "Toiture", ar: "أسقف" },
  tiling: { en: "Tiling", de: "Fliesenlegen", fr: "Carrelage", ar: "تبليط / زليج" },
  gardening: { en: "Gardening", de: "Gartenbau", fr: "Jardinage", ar: "بستنة" },
  cleaning: { en: "Cleaning", de: "Reinigung", fr: "Nettoyage", ar: "تنظيف" },
  moving: { en: "Moving", de: "Umzug", fr: "Déménagement", ar: "نقل الأثاث" },
  masonry: { en: "Masonry", de: "Maurerarbeit", fr: "Maçonnerie", ar: "بناء" },
};

const cityNames = {
  "Casablanca": "الدار البيضاء", "Rabat": "الرباط", "Marrakech": "مراكش", "Fès": "فاس",
  "Tanger": "طنجة", "Agadir": "أكادير", "Meknès": "مكناس", "Oujda": "وجدة",
  "Kénitra": "القنيطرة", "Tétouan": "تطوان", "Salé": "سلا", "Essaouira": "الصويرة",
  "El Jadida": "الجديدة", "Nador": "الناظور", "Mohammedia": "المحمدية", "Safi": "آسفي",
  "Beni Mellal": "بني ملال", "Khouribga": "خريبكة", "Settat": "سطات", "Taza": "تازة",
  "Ouarzazate": "ورزازات", "Errachidia": "الرشيدية", "Ifrane": "إفران", "Chefchaouen": "شفشاون",
  "Al Hoceima": "الحسيمة", "Larache": "العرائش", "Berkane": "بركان", "Taroudant": "تارودانت",
  "Guelmim": "كلميم", "Laâyoune": "العيون", "Dakhla": "الداخلة",
};

const skillNames = {
  "Custom furniture": { en: "Custom furniture", de: "Maßmöbel", fr: "Meubles sur mesure", ar: "أثاث حسب الطلب" },
  "Zellige woodwork": { en: "Zellige woodwork", de: "Zellige-Holzarbeiten", fr: "Boiserie zellige", ar: "أعمال خشب الزليج" },
  "Interior fit-out": { en: "Interior fit-out", de: "Innenausbau", fr: "Aménagement intérieur", ar: "تجهيز داخلي" },
  "Bathroom reno": { en: "Bathroom reno", de: "Badsanierung", fr: "Rénovation salle de bain", ar: "تجديد الحمام" },
  "Leak repair": { en: "Leak repair", de: "Leckreparatur", fr: "Réparation de fuites", ar: "إصلاح التسربات" },
  "Water heaters": { en: "Water heaters", de: "Warmwasserboiler", fr: "Chauffe-eau", ar: "سخانات المياه" },
  "Smart home": { en: "Smart home", de: "Smart Home", fr: "Maison connectée", ar: "المنزل الذكي" },
  "Solar": { en: "Solar", de: "Solar", fr: "Solaire", ar: "الطاقة الشمسية" },
  "Inspections": { en: "Inspections", de: "Prüfungen", fr: "Inspections", ar: "الفحوصات" },
  "Interior": { en: "Interior", de: "Innenräume", fr: "Intérieur", ar: "الداخل" },
  "Facade": { en: "Facade", de: "Fassade", fr: "Façade", ar: "الواجهة" },
  "Tadelakt": { en: "Tadelakt", de: "Tadelakt", fr: "Tadelakt", ar: "التادلاكت" },
  "Repairs": { en: "Repairs", de: "Reparaturen", fr: "Réparations", ar: "إصلاحات" },
  "Waterproofing": { en: "Waterproofing", de: "Abdichtung", fr: "Étanchéité", ar: "العزل المائي" },
  "Terraces": { en: "Terraces", de: "Terrassen", fr: "Terrasses", ar: "الشرفات" },
  "Zellige": { en: "Zellige", de: "Zellige", fr: "Zellige", ar: "الزليج" },
  "Large format": { en: "Large format", de: "Großformat", fr: "Grand format", ar: "البلاط كبير الحجم" },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");
  const change = (l) => {
    setLang(l);
    localStorage.setItem("lang", l);
  };
  useEffect(() => {
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => (dict[lang] && dict[lang][key]) || dict.en[key] || key;
  const catName = (c) => (catNames[c] ? catNames[c][lang] : c);
  const money = (n) => (n == null ? "" : lang === "ar" ? `${n} د.م.` : `${n} DH`);
  const jt = (obj, field) => (obj && obj[`${field}_i18n`] && obj[`${field}_i18n`][lang]) || (obj ? obj[field] : "") || "";
  const cityName = (c) => (lang === "ar" && cityNames[c]) ? cityNames[c] : c;
  const skillName = (s) => (skillNames[s] ? skillNames[s][lang] : s);
  return (
    <I18nContext.Provider value={{ lang, setLang: change, t, catName, money, jt, cityName, skillName }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
export { catNames };